const vi = {
  'common.loading': 'Đang tải…',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.delete': 'Xóa',
  'common.search': 'Tìm kiếm',
  'common.accessDenied': 'Từ chối truy cập',
  'common.backToLogin': 'Quay lại đăng nhập',
  'common.markAsRead': 'Đánh dấu đã đọc',
  'shell.supportDesk': 'Trung tâm hỗ trợ',
  'shell.searchPlaceholder': 'Tìm kiếm ticket, liên hệ, bài viết…',
  'shell.newTicket': 'Ticket mới',
  'shell.notifications': 'Thông báo',
  'shell.notificationPreferences': 'Tùy chọn thông báo',
  'shell.settings': 'Cài đặt',
  'shell.signOut': 'Đăng xuất',
  'shell.expandNavigation': 'Mở rộng điều hướng',
  'shell.collapseNavigation': 'Thu gọn điều hướng',
  'shell.caughtUp': 'Bạn đã xem hết',
  'shell.viewAllNotifications': 'Xem tất cả thông báo',
  'nav.dashboard': 'Bảng điều khiển',
  'nav.tickets': 'Ticket',
  'nav.contacts': 'Liên hệ',
  'nav.companies': 'Công ty',
  'nav.reports': 'Báo cáo',
  'nav.settings': 'Cài đặt',
  'nav.agents': 'Agent',
  'nav.groups': 'Nhóm',
  'nav.roles': 'Vai trò',
  'nav.tags': 'Thẻ',
  'nav.ticketFields': 'Trường ticket',
  'nav.ticketForms': 'Biểu mẫu ticket',
  'nav.businessHours': 'Giờ làm việc',
  'nav.slaPolicies': 'Chính sách SLA',
  'nav.automations': 'Tự động hóa',
  'nav.email': 'Email',
  'nav.notificationTemplates': 'Mẫu thông báo',
  'nav.apiKeys': 'Khóa API',
  'nav.cannedResponses': 'Câu trả lời soạn sẵn',
  'nav.knowledgeBase': 'Cơ sở kiến thức',
  'auth.signInTitle': 'Trung tâm hỗ trợ SDPL',
  'auth.signInSubtitle': 'Đăng nhập vào tài khoản của bạn',
  'auth.emailAddress': 'Địa chỉ email',
  'auth.password': 'Mật khẩu',
  'auth.signingIn': 'Đang đăng nhập…',
  'auth.signIn': 'Đăng nhập',
  'auth.forgotPassword': 'Quên mật khẩu?',
  'auth.twoFactor': 'Xác thực hai yếu tố',
  'auth.verificationCode': 'Mã xác minh',
  'auth.verify': 'Xác minh',
  'auth.backToLogin': 'Quay lại đăng nhập',
  'agents.title': 'Agent',
  'agents.new': 'Agent mới',
  'agents.supportAgents': 'Agent hỗ trợ',
  'agents.collaborators': 'Cộng tác viên',
  'agents.deactivated': 'Đã vô hiệu hóa',
  'agents.searchPlaceholder': 'Tìm theo tên hoặc email',
  'agents.edit': 'Chỉnh sửa',
  'agents.deactivate': 'Vô hiệu hóa',
  'agents.reactivate': 'Kích hoạt lại',
  'agents.saved': 'Đã lưu agent.',
  'agents.firstName': 'Tên',
  'agents.lastName': 'Họ',
  'agents.email': 'Email',
  'agents.phone': 'Điện thoại',
  'agents.timezone': 'Múi giờ',
  'agents.selectTimezone': 'Chọn múi giờ',
  'agents.language': 'Ngôn ngữ',
  'agents.selectLanguage': 'Chọn ngôn ngữ',
  'agents.emailSignature': 'Chữ ký email',
  'agents.roleRequired': 'Vai trò',
  'agents.selectRole': 'Chọn vai trò',
  'agents.status': 'Trạng thái',
  'agents.groupsTitle': 'Nhóm',
  'agents.manageGroups': 'Quản lý nhóm',
  'agents.notInGroup': 'Chưa thuộc nhóm nào',
  'dashboard.title': 'Bảng điều khiển',
  'dashboard.description': 'Khối lượng hỗ trợ và tình trạng dịch vụ hiện tại.',
  'dashboard.allGroups': 'Tất cả nhóm có thể truy cập',
  'dashboard.unresolved': 'Chưa giải quyết',
  'dashboard.overdue': 'Quá hạn',
  'dashboard.dueToday': 'Đến hạn hôm nay',
  'dashboard.open': 'Đang mở',
  'dashboard.onHold': 'Đang tạm giữ',
  'dashboard.unassigned': 'Chưa phân công',
  'dashboard.trends': 'Xu hướng hôm nay',
  'notifications.title': 'Thông báo',
  'notifications.description': 'Lịch sử thông báo đầy đủ của bạn.',
  'notifications.markAllRead': 'Đánh dấu tất cả đã đọc',
  'notifications.filter': 'Bộ lọc',
  'notifications.allTypes': 'Tất cả loại',
  'notifications.none': 'Chưa có thông báo',
  'notifications.assigned': 'Đã phân công',
  'notifications.reply': 'Phản hồi',
  'notifications.note': 'Ghi chú',
  'notifications.slaWarning': 'Cảnh báo SLA',
  'notifications.slaBreach': 'Vi phạm SLA',
  'notifications.slaEscalation': 'Leo thang SLA',
  'notifications.mention': 'Đề cập',
  'preferences.title': 'Tùy chọn thông báo',
  'preferences.description': 'Thông báo trong ứng dụng luôn bật. Chọn thông báo nào cũng gửi qua email.',
  'preferences.emailDigest': 'Tóm tắt email',
  'preferences.dailySummary': 'Nhận một email tóm tắt hằng ngày thay vì email cho từng sự kiện.',
  'preferences.digestOff': 'Tắt — email cho từng sự kiện',
  'preferences.digestDaily': 'Tóm tắt hằng ngày',
  'preferences.emailNotifications': 'Thông báo qua email',
  'activities.button': 'Hoạt động gần đây',
  'activities.title': 'Hoạt động gần đây',
  'activities.loadError': 'Không thể tải hoạt động gần đây.',
  'activities.systemActor': 'Hệ thống',
  'activities.noneTitle': 'Chưa có hoạt động gần đây',
  'activities.noneDescription': 'Các cập nhật ticket từ bạn và nhóm của bạn sẽ hiển thị ở đây khi chúng xảy ra.',
  'tickets.title': 'Ticket',
  'tickets.description': 'Tất cả ticket bạn có quyền truy cập, được lọc và sắp xếp theo cách bạn làm việc.',
  'tickets.dueDateTabs': 'Ngày hết hạn ticket',
  'tickets.tabAll': 'Tất cả ticket',
  'tickets.tabDueToday': 'Hạn hôm nay',
  'tickets.tabOverdue': 'Quá hạn',
  'tickets.tabDueTomorrow': 'Hạn ngày mai',
  'tickets.searchPlaceholder': 'Tìm kiếm ticket…',
  'tickets.searchAria': 'Tìm kiếm ticket',
  'tickets.filters': 'Bộ lọc',
  'tickets.filtersWithCount': 'Bộ lọc ({count})',
  'tickets.sortAria': 'Sắp xếp ticket theo',
  'tickets.sortTrigger': 'Sắp xếp: {label}',
  'tickets.sortDateCreated': 'Ngày tạo',
  'tickets.sortDateUpdated': 'Ngày cập nhật',
  'tickets.sortPriority': 'Mức độ ưu tiên',
  'tickets.sortStatus': 'Trạng thái',
  'tickets.sortDueDate': 'Ngày hết hạn',
  'tickets.sortAscending': 'Sắp xếp tăng dần',
  'tickets.sortDescending': 'Sắp xếp giảm dần',
  'tickets.ascending': 'Tăng dần',
  'tickets.descending': 'Giảm dần',
  'tickets.layoutAria': 'Bố cục hàng',
  'tickets.layoutTrigger': 'Bố cục: {label}',
  'tickets.layoutCard': 'Thẻ',
  'tickets.layoutInbox': 'Hộp thư đến',
  'tickets.layoutTable': 'Bảng',
  'tickets.export': 'Xuất',
  'tickets.exportSelected': 'Xuất mục đã chọn',
  'tickets.selectedCount': 'Đã chọn {count}',
  'tickets.assignAgent': 'Giao cho nhân viên',
  'tickets.closeAll': 'Đóng tất cả',
  'tickets.clearSelection': 'Bỏ chọn',
  'tickets.selectAgentPlaceholder': 'Chọn nhân viên...',
  'tickets.assignTo': 'Giao cho',
  'tickets.assign': 'Giao',
  'tickets.loadFailed': 'Không thể tải ticket. Vui lòng thử lại.',
  'tickets.bulkCloseFailed': 'Không thể đóng các ticket đã chọn. Vui lòng thử lại.',
  'tickets.bulkAssignFailed': 'Không thể giao các ticket đã chọn. Vui lòng thử lại.',
  'tickets.noFilterMatchTitle': 'Không có ticket nào khớp với các bộ lọc này',
  'tickets.noFilterMatchDescription': 'Hãy thử bỏ một bộ lọc, mở rộng khoảng thời gian hoặc tìm kiếm từ khác.',
  'tickets.clearFilters': 'Xóa bộ lọc',
  'tickets.queueClearTitle': 'Hàng đợi này đang trống',
  'tickets.queueClearDescription': 'Ticket mới sẽ hiển thị ở đây khi khách hàng gửi email, sử dụng cổng thông tin hoặc nhân viên tạo ticket.',
  'tickets.newTicket': 'Ticket mới',
  'tickets.selectAllAria': 'Chọn tất cả ticket',
  'tickets.selectTicketAria': 'Chọn ticket #{number}',
  'tickets.columnContact': 'Liên hệ',
  'tickets.columnSubject': 'Chủ đề',
  'tickets.columnState': 'Trạng thái',
  'tickets.columnGroup': 'Nhóm',
  'tickets.columnAgent': 'Nhân viên',
  'tickets.columnPriority': 'Mức độ ưu tiên',
  'tickets.noGroup': 'Không có nhóm',
  'tickets.unassigned': 'Chưa giao',
  'tickets.createdRelative': 'Đã tạo {when}',
  'tickets.unassignedOnly': 'Chỉ chưa giao',
  'tickets.unknownRequester': 'Người yêu cầu không xác định',
  'tickets.overdueBy': 'Quá hạn {duration}',
  'tickets.dueIn': 'Hết hạn trong {duration}',
  'tickets.filtersDrawerTitle': 'Bộ lọc',
  'tickets.filtersSearchPlaceholder': 'Tìm kiếm trường',
  'tickets.filtersSearchAria': 'Tìm kiếm trường bộ lọc',
  'tickets.filtersClearAll': 'Xóa tất cả',
  'tickets.filtersApply': 'Áp dụng',
  'tickets.filterAgents': 'Nhân viên',
  'tickets.filterAnyAgent': 'Bất kỳ nhân viên nào',
  'tickets.filterGroups': 'Nhóm',
  'tickets.filterAnyGroup': 'Bất kỳ nhóm nào',
  'tickets.filterStatus': 'Trạng thái',
  'tickets.filterAnyStatus': 'Bất kỳ trạng thái nào',
  'tickets.filterPriority': 'Mức độ ưu tiên',
  'tickets.filterAnyPriority': 'Bất kỳ mức độ ưu tiên nào',
  'tickets.filterSource': 'Nguồn',
  'tickets.filterAnySource': 'Bất kỳ nguồn nào',
  'tickets.filterTicketType': 'Loại ticket',
  'tickets.filterAnyType': 'Bất kỳ loại nào',
  'tickets.filterTags': 'Thẻ',
  'tickets.filterAnyTag': 'Bất kỳ thẻ nào',
  'tickets.filterCompanies': 'Công ty',
  'tickets.filterAnyCompany': 'Bất kỳ công ty nào',
  'tickets.filterCreated': 'Đã tạo',
  'tickets.filterResolvedAt': 'Đã giải quyết lúc',
  'tickets.filterClosedAt': 'Đã đóng lúc',
  'tickets.filterDateFrom': '{label} từ',
  'tickets.filterDateTo': '{label} đến',
  'tickets.filterDateTo2': 'đến',
  'tickets.filterAny': 'Bất kỳ',
  'tickets.chipFieldStatus': 'Trạng thái',
  'tickets.chipFieldPriority': 'Mức độ ưu tiên',
  'tickets.chipFieldGroup': 'Nhóm',
  'tickets.chipFieldAssignee': 'Người được giao',
  'tickets.chipValueGroup': 'Nhóm',
  'tickets.chipValueUnassigned': 'Chưa giao',
  'common.saving': 'Đang lưu…',
  'common.clearSearch': 'Xóa tìm kiếm',
  'common.sortBy': 'Sắp xếp theo',
  'common.name': 'Tên',
  'common.role': 'Vai trò',
  'common.groups': 'Nhóm',
  'common.tickets': 'Ticket',
  'common.lastSeen': 'Lần cuối hoạt động',
  'common.actions': 'Hành động',
  'common.never': 'Chưa bao giờ',
  'common.justNow': 'Vừa xong',
  'common.minutesAgo': '{count} phút trước',
  'common.hoursAgo': '{count} giờ trước',
  'common.daysAgo': '{count} ngày trước',
  'common.noPagePermission': 'Bạn không có quyền truy cập trang này.',
  'common.roleNoPermission': 'Vai trò của bạn không có quyền truy cập trang này.',
  'common.requestFailed': 'Yêu cầu không thành công. Vui lòng thử lại.',
  'common.unexpectedError': 'Đã xảy ra lỗi không mong muốn',
  'common.user': 'Người dùng',
  'shell.skipToMain': 'Chuyển đến nội dung chính',
  'shell.homeLabel': 'Trang chủ Suzuki Support Desk',
  'shell.userMenu': 'Menu người dùng',
  'shell.unread': '{count} chưa đọc',
  'shell.adminNavigation': 'Điều hướng quản trị',
  'shell.notificationDescription': 'Các phân công, phản hồi và cảnh báo SLA mới sẽ hiển thị ở đây.',
  'auth.enterAuthenticatorCode': 'Nhập mã 6 chữ số từ ứng dụng xác thực của bạn',
  'auth.verifying': 'Đang xác minh…',
  'auth.setupAuthenticator': 'Thiết lập trình xác thực',
  'auth.scanAuthenticator': 'Quét mã này bằng ứng dụng xác thực của bạn (Google Authenticator, Authy, v.v.)',
  'auth.authenticatorSetupQr': 'Mã QR thiết lập trình xác thực',
  'auth.verificationCodeFromAuthenticator': 'Mã xác minh từ trình xác thực',
  'auth.verifyAndComplete': 'Xác minh và hoàn tất thiết lập',
  'auth.loadingSetup': 'Đang tải thiết lập…',
  'auth.setNewPassword': 'Đặt mật khẩu mới',
  'auth.temporaryPasswordExpired': 'Mật khẩu tạm thời của bạn đã hết hạn. Vui lòng đặt mật khẩu mới.',
  'auth.newPassword': 'Mật khẩu mới',
  'auth.confirmPassword': 'Xác nhận mật khẩu',
  'auth.settingPassword': 'Đang đặt mật khẩu…',
  'auth.setPassword': 'Đặt mật khẩu',
  'auth.passwordRequirements': 'Yêu cầu ít nhất 8 ký tự, chữ hoa, chữ thường, số và ký hiệu',
  'auth.tooManyAttempts': 'Quá nhiều lần đăng nhập. Vui lòng thử lại sau.',
  'auth.invalidCredentials': 'Email hoặc mật khẩu không hợp lệ',
  'auth.passwordsDoNotMatch': 'Mật khẩu không khớp',
  'auth.passwordMinimum': 'Mật khẩu phải có ít nhất {count} ký tự',
  'auth.resetTitle': 'Đặt lại mật khẩu của bạn',
  'auth.resetSubtitle': 'Nhập email của bạn và chúng tôi sẽ gửi liên kết đặt lại',
  'auth.checkEmail': 'Kiểm tra email của bạn để lấy liên kết đặt lại',
  'auth.checkCode': 'Kiểm tra email để lấy mã xác minh, sau đó tiếp tục bên dưới.',
  'auth.continueToReset': 'Tiếp tục đặt lại mật khẩu',
  'auth.sendResetLink': 'Gửi liên kết đặt lại',
  'auth.sending': 'Đang gửi…',
  'auth.resetSuccess': 'Mật khẩu của bạn đã được đặt lại thành công.',
  'auth.goToLogin': 'Đi đến đăng nhập',
  'auth.missingResetToken': 'Thiếu token đặt lại. Vui lòng sử dụng liên kết từ email của bạn.',
  'auth.enterCodeFromEmail': 'Nhập mã xác minh được gửi đến email của bạn',
  'auth.codeFromEmail': 'Nhập mã từ email',
  'auth.emailRequired': 'Email là bắt buộc',
  'auth.codeRequired': 'Mã xác minh là bắt buộc',
  'auth.missingToken': 'Thiếu token đặt lại',
  'auth.failedReset': 'Đặt lại mật khẩu không thành công.',
  'auth.resetting': 'Đang đặt lại…',
  'auth.resetPassword': 'Đặt lại mật khẩu',
  'auth.looksGood': 'Trông ổn',
  'auth.needCharacters': 'Cần ít nhất {count} ký tự',
  'auth.passwordFormat': 'Yêu cầu ít nhất {count} ký tự, chữ hoa, chữ thường, số và ký hiệu',
  'agents.description': 'Những người xử lý ticket. Chỉ định vai trò để kiểm soát những gì họ có thể làm, và nhóm để kiểm soát những gì họ thấy.',
  'agents.searchAria': 'Tìm kiếm nhân viên',
  'agents.countOne': '{count} nhân viên',
  'agents.countMany': '{count} nhân viên',
  'agents.ticketOne': '{count} ticket',
  'agents.ticketMany': '{count} ticket',
  'agents.noGroups': 'Không có nhóm',
  'agents.lifecycle': 'Chu kỳ hoạt động của nhân viên',
  'agents.noSearchResults': 'Không có nhân viên nào khớp với tìm kiếm này',
  'agents.noAgentsView': 'Không có nhân viên trong chế độ xem này',
  'agents.tryDifferent': 'Hãy thử tên hoặc địa chỉ email khác.',
  'agents.useNewAgent': 'Sử dụng Nhân viên mới để thêm người, hoặc chuyển tab để xem các nhân viên khác.',
  'agents.agent': 'Nhân viên',
  'agents.noRole': 'Không có vai trò',
  'agents.openTicketsTitle': 'Ticket đang mở hiện được giao cho nhân viên này',
  'agents.moreActions': 'Thêm hành động cho {name}',
  'agents.confirmDeleteTitle': 'Xóa {name}?',
  'agents.confirmDeleteDescription': 'Không thể hoàn tác việc này. Nhân viên được liên kết với ticket không thể bị xóa; hãy vô hiệu hóa họ thay vào đó.',
  'agents.confirmDeleteLabel': 'Xóa nhân viên',
  'agents.agentsVsCollaborators': 'Nhân viên và Cộng tác viên',
  'agents.agentsVsCollaboratorsBody': 'Nhân viên hỗ trợ xử lý ticket hàng ngày. Cộng tác viên có vai trò cộng tác viên và thường là chuyên gia được đưa vào các ticket riêng lẻ mà không có quyền truy cập nhân viên đầy đủ.',
  'agents.deactivateVsDelete': 'Vô hiệu hóa và Xóa',
  'agents.deactivateVsDeleteBody': 'Vô hiệu hóa giữ nguyên lịch sử và quyền sở hữu ticket nhưng chặn đăng nhập. Xóa là vĩnh viễn và chỉ hoạt động khi nhân viên không có ticket liên kết.',
  'agents.newTitle': 'Nhân viên mới',
  'agents.editTitle': 'Chỉnh sửa nhân viên',
  'agents.temporaryPassword': 'Mật khẩu tạm thời',
  'agents.passwordHelp': 'Ít nhất 12 ký tự. Nhân viên có thể thay đổi sau khi đăng nhập.',
  'agents.timezoneHelp': 'Mọi ngày và giờ mà nhân viên này thấy đều được hiển thị theo múi giờ này.',
  'agents.languageHelp': 'Dịch giao diện dành cho nhân viên. Phản hồi ticket và nội dung khách hàng không được dịch.',
  'agents.signaturePlaceholder': 'Được thêm vào các phản hồi gửi đi',
  'agents.roleHelp': 'Xác định những gì nhân viên này có thể làm.',
  'agents.manageRoles': 'Quản lý vai trò',
  'agents.activeHelp': 'Hoạt động — bỏ chọn sẽ chặn đăng nhập mà không xóa nhân viên',
  'agents.groupHelp': 'Thêm nhân viên này vào một nhóm từ màn hình Nhóm để kiểm soát ticket nào họ thấy.',
  'agents.about': 'Về nhân viên này',
  'agents.aboutBody': 'Tên, email, điện thoại, múi giờ, ngôn ngữ và chữ ký xác định nhân viên và cá nhân hóa không gian làm việc của họ. Vai trò kiểm soát những gì họ có thể làm; thành viên nhóm kiểm soát ticket nào họ thấy.',
  'dashboard.trendsDescription': 'Tạo ticket theo giờ UTC, so với hôm qua.',
  'dashboard.today': 'Hôm nay',
  'dashboard.yesterday': 'Hôm qua',
  'dashboard.chartAria': 'Số lượng ticket theo giờ UTC, hôm nay so với hôm qua',
  'dashboard.dataUnavailable': 'Dữ liệu bảng điều khiển không có sẵn.',
  'dashboard.loadError': 'Không thể tải dữ liệu bảng điều khiển. Vui lòng thử lại.',
  'notifications.noType': 'Không có thông báo loại này',
  'notifications.allTypesHint': 'Chọn "Tất cả loại" ở trên để xem phần còn lại của lịch sử của bạn.',
  'notifications.emptyDescription': 'Các phân công, phản hồi và cảnh báo SLA sẽ xuất hiện ở đây. Điều chỉnh loại nào cũng gửi email cho bạn trong tùy chọn thông báo.',
  'preferences.digestWarning': 'Bạn đang dùng tóm tắt hằng ngày, vì vậy các cài đặt này sẽ bị bỏ qua cho đến khi bạn tắt nó.',
  'preferences.assignedEvent': 'Một ticket được giao cho bạn',
  'preferences.replyEvent': 'Một ticket bạn tham gia nhận được phản hồi',
  'preferences.noteEvent': 'Một ghi chú riêng tư được thêm vào',
  'preferences.slaWarningEvent': 'SLA đang đến gần hạn',
  'preferences.slaBreachEvent': 'SLA bị vi phạm',
  'preferences.slaEscalationEvent': 'SLA leo thang quá hạn',
  'preferences.mentionEvent': 'Bạn được đề cập trên một ticket',

  'ticketDetail.back': 'Quay lại',
  'ticketDetail.follow': 'Theo dõi',
  'ticketDetail.following': 'Đang theo dõi',
  'ticketDetail.hideActivities': 'Ẩn hoạt động',
  'ticketDetail.activitiesButton': 'Hoạt động',
  'ticketDetail.attachmentsCount': 'Tệp đính kèm ({count})',
  'ticketDetail.threadAria': 'Luồng ticket',
  'ticketDetail.conversationsTabLabel': 'Cuộc trò chuyện',
  'ticketDetail.activitiesTabLabel': 'Hoạt động',
  'ticketDetail.noRepliesYet': 'Chưa có phản hồi',
  'ticketDetail.noRepliesDescription': 'Sử dụng khung soạn bên dưới để trả lời người yêu cầu hoặc thêm ghi chú nội bộ.',
  'ticketDetail.privateNote': 'Ghi chú riêng tư',
  'ticketDetail.forward': 'Đã chuyển tiếp',
  'ticketDetail.uploadingAria': 'Đang tải lên',
  'ticketDetail.uploadingProgress': 'Đang tải lên {uploading}/{total} tệp…',
  'ticketDetail.uploadsFailed': '{count} tệp tải lên thất bại',
  'ticketDetail.retry': 'Thử lại',
  'ticketDetail.dismiss': 'Đóng',
  'ticketDetail.noActivityYet': 'Chưa có hoạt động',
  'ticketDetail.noActivityDescription': 'Các thay đổi về trạng thái, nhân viên và SLA sẽ được liệt kê ở đây khi ticket tiến triển.',
  'ticketDetail.requester': 'Người yêu cầu',
  'ticketDetail.properties': 'Thuộc tính',
  'ticketDetail.updating': 'Đang cập nhật…',
  'ticketDetail.update': 'Cập nhật',
  'ticketDetail.tags': 'Thẻ',
  'ticketDetail.relationships': 'Quan hệ',
  'ticketDetail.parentTicket': 'Ticket cha',
  'ticketDetail.unlink': 'Bỏ liên kết',
  'ticketDetail.noParentTicket': 'Không có ticket cha',
  'ticketDetail.childTicketsCount': 'Ticket con ({count})',
  'ticketDetail.noChildTickets': 'Không có ticket con',
  'ticketDetail.findTicket': 'Tìm ticket',
  'ticketDetail.ticketSearchPlaceholder': 'Số ticket hoặc chủ đề',
  'ticketDetail.searchButton': 'Tìm kiếm',
  'ticketDetail.setParent': 'Đặt làm ticket cha',
  'ticketDetail.mergeIntoAction': 'Hợp nhất vào',
  'ticketDetail.splitIntoChild': 'Tách thành ticket con',
  'ticketDetail.newTicketSubjectPlaceholder': 'Chủ đề ticket mới',
  'ticketDetail.splitButton': 'Tách',
  'ticketDetail.copyAttachments': 'Sao chép tệp đính kèm',
  'ticketDetail.copyConversationHistory': 'Sao chép lịch sử trò chuyện',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Đã tạm dừng',
  'ticketDetail.editButton': 'Chỉnh sửa',
  'ticketDetail.setResolutionDueDate': 'Đặt hạn giải quyết',
  'ticketDetail.pickDateTime': 'Chọn ngày & giờ',
  'ticketDetail.resolutionDueLabel': 'Hạn giải quyết',
  'ticketDetail.saveSla': 'Lưu SLA',
  'ticketDetail.savingSla': 'Đang lưu…',
  'ticketDetail.noSlaPolicy': 'Không có chính sách SLA áp dụng cho ticket này.',
  'ticketDetail.firstResponse': 'Phản hồi đầu tiên',
  'ticketDetail.resolution': 'Giải quyết',
  'ticketDetail.done': 'Hoàn thành',
  'ticketDetail.pausedSince': 'Đã tạm dừng từ {date}',
  'ticketDetail.escalation': 'Leo thang',
  'ticketDetail.escalatedLevel2': 'Đã leo thang (Cấp 2)',
  'ticketDetail.escalated': 'Đã leo thang',
  'ticketDetail.dueDateOverridden': 'Hạn đã được quản trị viên ghi đè thủ công.',
  'ticketDetail.dates': 'Ngày',
  'ticketDetail.created': 'Đã tạo',
  'ticketDetail.updated': 'Đã cập nhật',
  'ticketDetail.resolved': 'Đã giải quyết',
  'ticketDetail.closed': 'Đã đóng',
  'ticketDetail.loadErrorTitle': 'Không thể tải ticket này',
  'ticketDetail.notFound': 'Không tìm thấy ticket',
  'ticketDetail.confirmMergeTitle': 'Hợp nhất ticket #{source} vào #{target}?',
  'ticketDetail.confirmMergeDescription': 'Ticket hiện tại sẽ bị đóng. Không thể hoàn tác hành động này.',
  'ticketDetail.confirmMergeLabel': 'Hợp nhất ticket',
  'ticketDetail.updateSuccess': 'Đã cập nhật ticket',
  'ticketDetail.updateError': 'Không thể cập nhật ticket',
  'ticketDetail.pickDateTitle': 'Chọn ngày',
  'ticketDetail.pickDateDescription': 'Chọn hạn giải quyết.',
  'ticketDetail.slaUpdateSuccess': 'Đã cập nhật SLA',
  'ticketDetail.slaUpdateError': 'Không thể cập nhật SLA',
  'ticketDetail.searchError': 'Không thể tìm kiếm ticket',
  'ticketDetail.parentUpdateError': 'Không thể cập nhật ticket cha',
  'ticketDetail.mergeSuccess': 'Đã hợp nhất vào #{number}',
  'ticketDetail.mergeError': 'Không thể hợp nhất ticket',
  'ticketDetail.splitSuccess': 'Đã tạo tách ticket',
  'ticketDetail.splitError': 'Không thể tách ticket',
  'ticketDetail.downloadError': 'Không thể tải tệp đính kèm',
  'ticketDetail.followSuccess': 'Đang theo dõi ticket',
  'ticketDetail.unfollowSuccess': 'Đã ngừng theo dõi ticket',
  'ticketDetail.watcherError': 'Không thể cập nhật trạng thái theo dõi',
  'ticketDetail.fieldsLoadError': 'Không thể tải các trường ticket',
  'ticketDetail.overdueBy': 'Quá hạn {label}',
  'ticketDetail.dueLeft': 'Còn lại {label}',
  'ticketDetail.presetToday': 'Hôm nay',
  'ticketDetail.presetTomorrow': 'Ngày mai',
  'ticketDetail.presetThisWeek': 'Tuần này',
  'ticketDetail.presetNextWeek': 'Tuần sau',
  'ticketDetail.presetThisMonth': 'Tháng này',
  'ticketDetail.eventTicketCreated': 'Đã tạo ticket',
  'ticketDetail.eventStatusUpdated': 'Đã cập nhật trạng thái',
  'ticketDetail.eventAgentUpdated': 'Đã cập nhật nhân viên',
  'ticketDetail.eventSlaUpdated': 'Đã cập nhật SLA',
  'ticketDetail.eventTicketMerged': 'Đã hợp nhất ticket',
  'ticketDetail.eventMergeReceived': 'Đã nhận hợp nhất',
  'ticketDetail.eventTicketSplit': 'Đã tách ticket',
  'ticketDetail.eventUpdated': 'Đã cập nhật',
  'ticketDetail.eventSplitContentCopied': 'Đã sao chép nội dung tách',
  'ticketDetail.eventReplySent': 'Đã gửi phản hồi',
  'ticketDetail.eventNoteAdded': 'Đã thêm ghi chú',
  'ticketDetail.eventCustomerReplied': 'Khách hàng đã phản hồi',
  'ticketDetail.eventTicketDeleted': 'Đã xóa ticket',
  'preferences.createdEvent': 'Đã tạo ticket',
  'preferences.pendingInputEvent': 'Ticket đang chờ phản hồi của bạn',
  'preferences.resolvedEvent': 'Ticket đã được giải quyết',
  'agents.assignGroups': 'Gán nhóm',
  'agents.assignGroupsHelp': 'Thành viên nhóm quyết định những ticket mà agent này có thể xem.',
  'agents.selectGroups': 'Chọn nhóm',
  'agents.ticketVisibility': 'Phạm vi hiển thị ticket',
  'agents.ticketVisibilityHelp': 'Chọn phạm vi hẹp hơn cho từng agent hoặc kế thừa mặc định của vai trò. Quyền của vai trò vẫn quyết định agent có thể làm gì.',
  'agents.scopeRoleDefault': 'Sử dụng mặc định của vai trò',
  'agents.scopeRoleDefaultHelp': 'Kế thừa phạm vi hiển thị mặc định được cấu hình cho vai trò này.',
  'agents.scopeAll': 'Tất cả ticket',
  'agents.scopeAllHelp': 'Xem mọi ticket chưa bị xóa trong tài khoản này.',
  'agents.scopeGroup': 'Ticket trong nhóm',
  'agents.scopeGroupHelp': 'Xem các ticket được gán cho những nhóm mà agent này thuộc về.',
  'agents.scopeAssigned': 'Ticket được gán',
  'agents.scopeAssignedHelp': 'Xem các ticket được gán trực tiếp cho agent này.',
  'agents.scopeCollaboratorHelp': 'Cộng tác viên vẫn bị giới hạn ở các ticket trong nhóm L1 của họ.',
  'nav.jira': 'Tích hợp Jira',
  'notifications.groupAssigned': 'Phân công nhóm',
  'notifications.groupMemberAdded': 'Được thêm vào nhóm',
  'preferences.groupAssignedEvent': 'Một ticket được giao cho một trong các nhóm của bạn',
  'preferences.groupMemberAddedEvent': 'Bạn được thêm vào một nhóm hỗ trợ',
  'ui.select': 'Chọn…',
  'ui.any': 'Bất kỳ',
  'ui.typeToSearch': 'Nhập để tìm kiếm…',
  'ui.noResults': 'Không tìm thấy kết quả',
  'ui.clearSelection': 'Xóa lựa chọn',
  'ui.removeItem': 'Xóa {label}',
  'ui.pressEnterToUse': 'Nhấn Enter để dùng giá trị này',
  'ui.removeFilter': 'Xóa bộ lọc {field}: {value}',
  'ui.removeTag': 'Xóa thẻ {label}',
  'ui.retry': 'Thử lại',
  'ui.errorTitle': 'Không thể tải nội dung này',
  'ui.errorMessage': 'Kiểm tra kết nối của bạn và thử lại.',
  'ui.reference': 'Mã tham chiếu: {id}',
  'ui.thisArea': 'khu vực này',
  'ui.noAccess': 'Bạn không có quyền truy cập {area}',
  'ui.noAccessHint': 'Hãy nhờ quản trị viên cấp quyền cần thiết.',
  'ui.actionFailed': 'Không thể hoàn tất thao tác này. Hãy thử lại.',
  'ui.slaPaused': 'SLA đã tạm dừng',
  'ui.filteredEmptyTitle': 'Không có ticket nào khớp với các bộ lọc này',
  'ui.filteredEmptyDescription': 'Hãy thử bỏ một bộ lọc hoặc mở rộng khoảng thời gian.',
  'ui.clearFilters': 'Xóa bộ lọc',
  'pagination.noResults': 'Không có kết quả',
  'pagination.showing': 'Hiển thị {first}–{last} trong {total}',
  'pagination.resultsPerPage': 'Kết quả mỗi trang',
  'pagination.perPage': '{count} mỗi trang',
  'pagination.previous': 'Trước',
  'pagination.next': 'Tiếp',
  'pagination.previousAria': 'Trang trước',
  'pagination.nextAria': 'Trang tiếp',
  'pagination.pageOf': 'Trang {page} / {total}',
  'status.open': 'Mở',
  'status.to_be_prioritised': 'Chờ ưu tiên',
  'status.work_in_progress': 'Đang xử lý',
  'status.assigned_to_ai_agent': 'Đã giao cho AI Agent',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Đang chờ',
  'status.awaiting_user_reply': 'Chờ người dùng phản hồi',
  'status.awaiting_resolution_confirmation': 'Chờ xác nhận giải quyết',
  'status.on_hold': 'Tạm giữ',
  'status.pending_production_release': 'Chờ phát hành lên production',
  'status.product_cr': 'CR sản phẩm',
  'status.reopened': 'Đã mở lại',
  'status.issue_fixed': 'Đã sửa lỗi',
  'status.resolved': 'Đã giải quyết',
  'status.closed': 'Đã đóng',
  'status.unknown': 'Không xác định',
  'priority.low': 'Thấp',
  'priority.medium': 'Trung bình',
  'priority.high': 'Cao',
  'priority.urgent': 'Khẩn cấp',
  'source.email': 'Email',
  'source.portal': 'Cổng thông tin',
  'source.phone': 'Điện thoại',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Chat web',
  'source.web_form': 'Biểu mẫu web',
  'source.forum': 'Diễn đàn',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget phản hồi',
  'source.outbound_email': 'Email gửi đi',
  'source.ecommerce': 'Thương mại điện tử',
  'source.bot': 'Bot',
  'source.instagram_message': 'Tin nhắn Instagram',
  'source.instagram_comment': 'Bình luận Instagram',
  'source.facebook_message': 'Tin nhắn Facebook',
  'source.facebook_comment': 'Bình luận Facebook',
  'source.mobile_chat_sdk': 'SDK chat di động',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Chế độ xem đã lưu',
  'savedViews.saveCurrent': 'Lưu bộ lọc hiện tại thành chế độ xem',
  'savedViews.namePlaceholder': 'Tên chế độ xem...',
  'savedViews.nameAria': 'Tên chế độ xem',
  'savedViews.empty': 'Chưa có chế độ xem nào được lưu. Áp dụng bộ lọc và lưu tại đây.',
  'savedViews.listAria': 'Danh sách chế độ xem đã lưu',
  'savedViews.rename': 'Đổi tên chế độ xem “{name}”',
  'savedViews.delete': 'Xóa chế độ xem “{name}”',
  'export.title': 'Xuất ticket',
  'export.loadError': 'Không thể tải danh sách trường xuất.',
  'export.failed': 'Xuất thất bại. Vui lòng thử lại.',
  'export.pdfFailed': 'Xuất PDF thất bại. Vui lòng thử lại.',
  'export.fieldsSelectedOne': 'Đã chọn {count} trường',
  'export.fieldsSelectedMany': 'Đã chọn {count} trường',
  'export.fieldsTotalOne': 'Tổng {count} trường',
  'export.fieldsTotalMany': 'Tổng {count} trường',
  'export.selectAllFields': 'Chọn tất cả các trường',
  'export.exportingOne': 'Đang xuất 1 ticket đã chọn.',
  'export.exportingMany': 'Đang xuất {count} ticket đã chọn.',
  'export.pdfZip': 'Tải xuống dạng PDF (.zip, {count} tệp)',
  'export.pdf': 'Tải xuống dạng PDF',
  'export.pdfZipHint': 'Tạo một PDF cho mỗi ticket và nén chúng thành một tệp ZIP duy nhất để tải xuống.',
  'export.pdfHint': 'Tạo một PDF duy nhất gồm thuộc tính ticket và luồng hội thoại công khai.',
  'export.formatLabel': 'Xuất dưới dạng (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Đang tải danh sách trường…',
  'export.ticketFields': 'Trường ticket',
  'export.contactFields': 'Trường liên hệ',
  'export.companyFields': 'Trường công ty',
  'export.exporting': 'Đang xuất…',
  'newTicket.title': 'Tạo ticket',
  'newTicket.description': 'Chọn một biểu mẫu đã lưu và điền các trường của biểu mẫu.',
  'newTicket.form': 'Biểu mẫu ticket',
  'newTicket.noForms': 'Không có biểu mẫu ticket nào. Hãy cấu hình một biểu mẫu trước khi tạo ticket.',
  'newTicket.loadFormsError': 'Không thể tải các biểu mẫu ticket',
  'newTicket.loadFormError': 'Không thể tải biểu mẫu ticket đã chọn',
  'newTicket.addCc': 'Thêm CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Xóa {name}',
  'newTicket.requesterRequired': 'Bắt buộc có người yêu cầu',
  'newTicket.subjectRequired': 'Bắt buộc có tiêu đề',
  'newTicket.createFailed': 'Tạo ticket thất bại',
  'newTicket.noFormTitle': 'Không có biểu mẫu ticket nào',
  'newTicket.noFormDescription': 'Hãy tạo biểu mẫu ticket trong Cài đặt, rồi quay lại để mở ticket.',
  'newTicket.noFieldsTitle': 'Biểu mẫu này chưa có trường nào',
  'newTicket.noFieldsDescription': 'Hãy thêm trường vào biểu mẫu trong Cài đặt, rồi tải lại trang này.',
  'newTicket.creating': 'Đang tạo...',
  'newTicket.submit': 'Tạo ticket',
  'fields.required': '{label} là bắt buộc',
  'fields.selectParentFirst': 'Hãy chọn giá trị cha trước...',
  'fields.selectPlaceholder': 'Chọn {label}...',
  'fields.enterPlaceholder': 'Nhập {label}...',
  'fields.optionsLoadError': 'Không thể tải các tùy chọn {label}',
  'fields.label.requester': 'Người yêu cầu',
  'fields.label.subject': 'Tiêu đề',
  'fields.label.description': 'Mô tả',
  'fields.label.status': 'Trạng thái',
  'fields.label.priority': 'Mức ưu tiên',
  'fields.label.source': 'Nguồn',
  'fields.label.ticket_type': 'Loại',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Nhóm',
  'fields.label.internal_agent': 'Agent nội bộ',
  'fields.label.internal_group': 'Nhóm nội bộ',
  'fields.label.company': 'Công ty',
  'editor.defaultPlaceholder': 'Nhập tại đây...',
  'editor.ariaLabel': 'Trình soạn thảo văn bản đa dạng thức',
  'editor.toolbarAria': 'Định dạng văn bản',
  'editor.bold': 'In đậm (Ctrl+B)',
  'editor.italic': 'In nghiêng (Ctrl+I)',
  'editor.underline': 'Gạch chân (Ctrl+U)',
  'editor.strikethrough': 'Gạch ngang',
  'editor.heading1': 'Tiêu đề 1',
  'editor.heading2': 'Tiêu đề 2',
  'editor.textColor': 'Màu chữ',
  'editor.highlight': 'Tô sáng',
  'editor.bulletList': 'Danh sách dấu đầu dòng',
  'editor.numberedList': 'Danh sách đánh số',
  'editor.blockquote': 'Trích dẫn',
  'editor.codeBlock': 'Khối mã',
  'editor.insertLink': 'Chèn liên kết',
  'editor.insertImage': 'Chèn hình ảnh',
  'editor.insertTable': 'Chèn bảng',
  'editor.mention': 'Nhắc đến ai đó',
  'editor.undo': 'Hoàn tác (Ctrl+Z)',
  'editor.redo': 'Làm lại (Ctrl+Shift+Z)',
  'editor.attach': 'Đính kèm tệp',
  'editor.noAgents': 'Không tìm thấy agent nào',
  'editor.mentionSuggestions': 'Gợi ý nhắc đến',
  'editor.dialogLinkTitle': 'Chèn liên kết',
  'editor.dialogImageTitle': 'Chèn hình ảnh',
  'editor.linkHint': 'Nhập URL HTTP(S), mailto, neo hoặc URL tương đối.',
  'editor.imageHint': 'Nhập URL hình ảnh HTTP(S) hoặc URL tương đối.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Nhập URL HTTP(S), mailto, neo hoặc URL tương đối hợp lệ.',
  'editor.invalidImage': 'Nhập URL hình ảnh HTTP(S) hoặc URL tương đối hợp lệ.',
  'editor.selectTextForLink': 'Hãy chọn văn bản trước khi thêm liên kết.',
  'editor.imageInsertFailed': 'Không thể chèn hình ảnh vào đây.',
  'editor.insertLinkAction': 'Chèn liên kết',
  'editor.insertImageAction': 'Chèn hình ảnh',
  'search.dialogAria': 'Tìm kiếm toàn cục',
  'search.placeholder': 'Tìm ticket, liên hệ...',
  'search.aria': 'Tìm kiếm',
  'search.close': 'Đóng tìm kiếm',
  'search.noMatches': 'Không có kết quả khớp với “{query}”',
  'search.noMatchesHint': 'Hãy thử số ticket, email liên hệ hoặc tên công ty.',
  'search.hintBefore': 'Nhập ít nhất 2 ký tự để tìm kiếm. Nhấn',
  'search.hintAfter': 'để đóng.',

  'td.system': 'Hệ thống',
  'td.actionCreatedTicket': 'đã tạo ticket',
  'td.actionUpdatedFields': 'đã cập nhật {fields}',
  'td.fieldStatus': 'trạng thái',
  'td.fieldPriority': 'mức độ ưu tiên',
  'td.fieldSource': 'nguồn',
  'td.fieldType': 'loại',
  'td.fieldGroup': 'nhóm',
  'td.fieldAgent': 'agent',
  'td.fieldCompany': 'công ty',
  'td.fieldContact': 'liên hệ',
  'td.fieldSubject': 'chủ đề',
  'td.fieldDescription': 'mô tả',
  'td.fieldProduct': 'sản phẩm',
  'td.fieldResolutionDue': 'hạn giải quyết',
  'td.fieldFirstResponseDue': 'hạn phản hồi đầu tiên',
  'td.fieldTags': 'thẻ',
  'td.fieldParentTicket': 'ticket cha',
  'td.eventCreated': '{actor} đã tạo một ticket mới',
  'td.eventCreatedLinked': '{actor} đã tạo một ticket mới và liên kết với một ticket cha',
  'td.eventSplit': '{actor} đã tách ticket này và tạo ticket con{ref}',
  'td.eventMergeReceived': '{actor} đã gộp một ticket khác vào ticket này{ref}',
  'td.eventMerged': '{actor} đã gộp ticket này vào một ticket khác{ref}',
  'td.eventSplitCopied': '{actor} đã sao chép {conversations} và {attachments}',
  'td.conversationsOne': '{count} cuộc hội thoại',
  'td.conversationsMany': '{count} cuộc hội thoại',
  'td.attachmentsOne': '{count} tệp đính kèm',
  'td.attachmentsMany': '{count} tệp đính kèm',
  'td.eventUpdatedFields': '{actor} đã cập nhật {fields}',
  'td.invalidSlaState': 'Máy chủ trả về trạng thái SLA không hợp lệ.',
  'td.slaRefreshError': 'Không thể làm mới đồng hồ SLA.',
  'td.descriptionUpdated': 'Đã cập nhật mô tả',
  'td.descriptionUpdateError': 'Không thể cập nhật mô tả',
  'td.descriptionUpdateFailed': 'Cập nhật mô tả không thành công',
  'td.entryUpdated': 'Đã cập nhật mục',
  'td.entryUpdateError': 'Không thể cập nhật mục',
  'td.updateFailed': 'Cập nhật không thành công',
  'td.loadOlderError': 'Không thể tải các cuộc hội thoại cũ hơn',
  'td.loadFailed': 'Tải không thành công',
  'td.slaUpdateFailed': 'Cập nhật SLA không thành công',
  'td.reasonTooLong': 'Lý do không được vượt quá 500 ký tự.',
  'td.invalidDateTime': 'Hãy chọn ngày và giờ hợp lệ.',
  'td.slaDeadlineUpdated': 'Đã cập nhật thời hạn SLA',
  'td.slaConflict': 'Ticket đã thay đổi trong khi bạn chỉnh sửa dữ liệu SLA. Hãy tải lại trước khi thử lại.',
  'td.slaClearFailed': 'Xóa SLA không thành công',
  'td.slaTargetCleared': 'Đã xóa mục tiêu SLA',
  'td.slaClearError': 'Không thể xóa mục tiêu SLA',
  'td.noDescription': 'Chưa có mô tả.',
  'td.editDescriptionAria': 'Chỉnh sửa mô tả ticket',
  'td.download': 'Tải xuống',
  'td.downloadFile': 'Tải xuống {fileName}',
  'td.loadOlder': '↓ +{count} cuộc hội thoại',
  'td.loadOlderMany': '↓ +{count} cuộc hội thoại',
  'td.edited': '(đã chỉnh sửa)',
  'td.privateThread': 'Luồng riêng tư',
  'td.propertiesAria': 'Thuộc tính ticket',
  'td.expandProperties': 'Mở rộng thuộc tính',
  'td.collapseProperties': 'Thu gọn thuộc tính',
  'td.metric': 'Chỉ số',
  'td.firstResponseOption': 'Phản hồi đầu tiên',
  'td.resolutionOption': 'Giải quyết',
  'td.overrideHint': 'Đặt thời hạn ghi đè do máy chủ quyết định. Lý do được lưu trong lịch sử SLA.',
  'td.deadline': 'Thời hạn',
  'td.reasonOptional': 'Lý do (không bắt buộc)',
  'td.reasonPlaceholder': 'Ngoại lệ đã được phê duyệt hoặc bối cảnh vận hành',
  'td.clearResolutionOverride': 'Xóa ghi đè giải quyết',
  'td.clearEscalationTarget': 'Xóa mục tiêu leo thang',
  'td.toolsAria': 'Công cụ ticket và liên hệ',
  'td.ticketContext': 'Ngữ cảnh ticket',
  'td.knowledgeBase': 'Cơ sở kiến thức',
  'td.shortcutsAria': 'Lối tắt ngữ cảnh ticket',
  'td.showContext': 'Hiện ngữ cảnh ticket',
  'td.hideContext': 'Ẩn ngữ cảnh ticket',
  'td.openRow': 'Mở {label}',
  'td.editTicket': 'Chỉnh sửa ticket',
  'td.searchContactPlaceholder': 'Tìm kiếm liên hệ…',
  'td.describePlaceholder': 'Mô tả vấn đề…',
  'td.noAttachments': 'Không có tệp đính kèm',

  'tp.api.csrfUnavailable': 'Không thể thiết lập bảo vệ CSRF',
  'tp.api.noMfaChallenge': 'Không có thử thách MFA nào đang hoạt động',
  'tp.api.noMfaSetup': 'Không có thử thách thiết lập MFA nào đang hoạt động',
  'tp.api.noNewPasswordChallenge': 'Không có thử thách mật khẩu mới nào đang hoạt động',
  'tp.articles.isLinkedAria': '{title} đã được liên kết làm giải pháp',
  'tp.articles.linkAria': 'Liên kết {title} làm giải pháp',
  'tp.articles.linkAsSolution': 'Liên kết làm giải pháp',
  'tp.articles.linkedAsSolution': 'Đã liên kết làm giải pháp',
  'tp.articles.none': 'Không có bài viết gợi ý cho ticket này.',
  'tp.articles.title': 'Bài viết gợi ý',
  'tp.articles.views': '{count} lượt xem',
  'tp.attachment.loadingPreview': 'Đang tải bản xem trước…',
  'tp.attachment.previewUnavailable': 'Không có bản xem trước',
  'tp.charts.noData': 'Không có dữ liệu biểu đồ cho giai đoạn này.',
  'tp.charts.noRecords': 'Không có bản ghi nào trong giai đoạn này.',
  'tp.charts.period': 'Giai đoạn',
  'tp.charts.showingTop': 'Hiển thị {shown} phân đoạn hàng đầu trong tổng số {total}.',
  'tp.common.cancel': 'Hủy',
  'tp.common.clear': 'Xóa',
  'tp.common.loading': 'Đang tải…',
  'tp.common.send': 'Gửi',
  'tp.common.sending': 'Đang gửi…',
  'tp.common.system': 'Hệ thống',
  'tp.convActions.edit': 'Chỉnh sửa',
  'tp.convActions.thread': 'Bắt đầu một luồng',
  'tp.dashboard.new': 'Mới',
  'tp.dashboard.select': 'Chọn bảng điều khiển',
  'tp.forward.failed': 'Chuyển tiếp không thành công',
  'tp.forward.forwarded': 'Đã chuyển tiếp ticket',
  'tp.forward.forwarding': 'Đang chuyển tiếp…',
  'tp.forward.forwardingMany': 'Đang chuyển tiếp {count} cuộc hội thoại:',
  'tp.forward.forwardingOne': 'Đang chuyển tiếp 1 cuộc hội thoại:',
  'tp.forward.message': 'Tin nhắn',
  'tp.forward.messagePlaceholder': 'Thêm tin nhắn (không bắt buộc)…',
  'tp.forward.noContacts': 'Không tìm thấy liên hệ nào — hãy nhập đầy đủ địa chỉ email',
  'tp.forward.recipientEmail': 'Email người nhận',
  'tp.forward.recipientInvalid': 'Nhập địa chỉ email người nhận hợp lệ',
  'tp.forward.recipientRequired': 'Bắt buộc nhập email người nhận',
  'tp.forward.searchContact': 'Tìm liên hệ hoặc nhập email…',
  'tp.forward.title': 'Chuyển tiếp',
  'tp.forward.to': 'Đến',
  'tp.forward.useThisEmail': 'Nhấn Enter hoặc nhấp Chuyển tiếp để dùng email này',
  'tp.jira.addOptional': 'Thêm trường tùy chọn',
  'tp.jira.createAndLink': 'Tạo và liên kết issue',
  'tp.jira.createIssue': 'Tạo issue',
  'tp.jira.createTitle': 'Tạo issue Jira',
  'tp.jira.describePlaceholder': 'Mô tả vấn đề…',
  'tp.jira.description': 'Mô tả',
  'tp.jira.development': 'Phát triển',
  'tp.jira.enterDevelopment': 'Nhập thông tin phát triển',
  'tp.jira.hideOptional': 'Ẩn trường tùy chọn',
  'tp.jira.issueId': 'ID issue',
  'tp.jira.issueSummary': 'Tóm tắt issue',
  'tp.jira.issueType': 'Loại issue *',
  'tp.jira.lastSync': 'Đồng bộ gần nhất: {error}',
  'tp.jira.linkIssue': 'Liên kết issue',
  'tp.jira.linkTitle': 'Liên kết issue Jira',
  'tp.jira.linkedIssues': 'Issue đã liên kết',
  'tp.jira.linkedIssuesHint': 'Dùng khóa issue Jira, phân tách bằng dấu phẩy.',
  'tp.jira.linkedIssuesPlaceholder': 'ví dụ: SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Đang tải các trường Jira…',
  'tp.jira.loadingIssueTypes': 'Đang tải các loại issue…',
  'tp.jira.loadingProjects': 'Đang tải các dự án Jira…',
  'tp.jira.loadingUsers': 'Đang tải người dùng Jira…',
  'tp.jira.noLinks': 'Chưa có issue Jira nào được liên kết với ticket này.',
  'tp.jira.noneFound': 'Không tìm thấy issue Jira nào.',
  'tp.jira.notAvailableProject': 'Không khả dụng cho dự án này',
  'tp.jira.projects': 'Dự án *',
  'tp.jira.refresh': 'Làm mới',
  'tp.jira.refreshFields': 'Làm mới các trường Jira',
  'tp.jira.reporter': 'Người báo cáo',
  'tp.jira.requestFailed': 'Yêu cầu Jira không thành công. Vui lòng thử lại.',
  'tp.jira.searchBy': 'Tìm theo:',
  'tp.jira.searchIssue': 'Tìm issue',
  'tp.jira.searchIssuePlaceholder': 'Tìm issue…',
  'tp.jira.searchUsers': 'Tìm người dùng Jira',
  'tp.jira.searching': 'Đang tìm trong Jira…',
  'tp.jira.selectIssueType': 'Chọn loại issue',
  'tp.jira.selectProject': 'Chọn một dự án',
  'tp.jira.summary': 'Tóm tắt *',
  'tp.jira.syncOff': 'Tắt đồng bộ',
  'tp.jira.syncOn': 'Bật đồng bộ',
  'tp.jira.syncStatus': 'Đồng bộ trạng thái ticket sang Jira',
  'tp.jira.unassigned': 'Chưa phân công',
  'tp.jira.unlink': 'Hủy liên kết',
  'tp.jira.unlinkConfirm': 'Hủy liên kết issue',
  'tp.jira.unlinkDescription': 'Thao tác này xóa liên kết khỏi ticket nhưng không xóa issue Jira.',
  'tp.jira.unlinkTitle': 'Hủy liên kết {key}?',
  'tp.jira.untitled': 'Issue Jira chưa có tiêu đề',
  'tp.layout.loadingPage': 'Đang tải trang…',
  'tp.notFound.goToDashboard': 'Đến Bảng điều khiển',
  'tp.notFound.title': 'Không tìm thấy trang',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Khách hàng',
  'tp.reply.addNote': 'Thêm ghi chú',
  'tp.reply.attachmentNotAdded': 'Chưa thêm tệp đính kèm',
  'tp.reply.clickToExpand': 'Nhấp để mở rộng',
  'tp.reply.collapsedNote': 'Thêm ghi chú nội bộ…',
  'tp.reply.collapsedReply': 'Viết phản hồi hoặc ghi chú…',
  'tp.reply.conversationType': 'Loại hội thoại',
  'tp.reply.failedToSend': 'Gửi không thành công',
  'tp.reply.markNoteAs': 'Đánh dấu ghi chú là',
  'tp.reply.notVisibleToContact': 'Liên hệ không nhìn thấy',
  'tp.reply.notVisibleToContacts': 'Các liên hệ không nhìn thấy',
  'tp.reply.noteAdded': 'Đã thêm ghi chú',
  'tp.reply.notifyTo': 'Thông báo cho',
  'tp.reply.placeholderPrivateNote': 'Thêm ghi chú riêng tư...',
  'tp.reply.placeholderPublicNote': 'Thêm ghi chú công khai để người yêu cầu nhìn thấy...',
  'tp.reply.placeholderReply': 'Nhập phản hồi của bạn...',
  'tp.reply.private': 'Riêng tư',
  'tp.reply.public': 'Công khai',
  'tp.reply.removeFile': 'Xóa {name}',
  'tp.reply.replySent': 'Đã gửi phản hồi',
  'tp.reply.searchAgentsToNotify': 'Tìm agent để thông báo…',
  'tp.reply.sendReply': 'Gửi phản hồi',
  'tp.reply.sending': 'Đang gửi...',
  'tp.reply.tabNote': 'Ghi chú',
  'tp.reply.tabReply': 'Phản hồi',
  'tp.reply.uploadAttachment': 'Tải lên tệp đính kèm',
  'tp.reply.visibleToContact': 'Liên hệ nhìn thấy',
  'tp.reply.visibleToContacts': 'Các liên hệ nhìn thấy',
  'tp.sla.breached': 'Đã vi phạm',
  'tp.sla.cleared': 'Đã xóa',
  'tp.sla.configErrorNoDeadline': 'Lỗi cấu hình SLA. Không có thời hạn nào được suy ra.',
  'tp.sla.configurationError': 'Lỗi cấu hình',
  'tp.sla.couldNotLoad': 'Không thể tải đồng hồ SLA',
  'tp.sla.done': 'Hoàn tất',
  'tp.sla.dueIn': 'Hết hạn sau {duration}',
  'tp.sla.dueLine': 'Hạn: {date}',
  'tp.sla.dueNow': 'Đến hạn ngay',
  'tp.sla.escalated': 'Đã leo thang',
  'tp.sla.firstResponse': 'Phản hồi đầu tiên',
  'tp.sla.invalidDeadline': 'Thời hạn không hợp lệ',
  'tp.sla.mayBeStale': 'Đồng hồ SLA có thể đã lỗi thời',
  'tp.sla.noActiveCycle': 'Không có chu kỳ SLA đang hoạt động.',
  'tp.sla.noDeadline': 'Không có thời hạn',
  'tp.sla.noMetrics': 'Không có chỉ số SLA nào cho chu kỳ này.',
  'tp.sla.noPolicy': 'Chưa áp dụng chính sách SLA cho ticket này.',
  'tp.sla.notConfigured': 'Chưa cấu hình',
  'tp.sla.notStarted': 'Chưa bắt đầu',
  'tp.sla.overdueBy': 'Quá hạn {duration}',
  'tp.sla.overridden': 'Đã ghi đè',
  'tp.sla.overrideReason': 'Lý do ghi đè: {reason}',
  'tp.sla.paused': 'Đã tạm dừng',
  'tp.sla.refreshing': 'Đang làm mới đồng hồ SLA chính thức…',
  'tp.sla.resolution': 'Giải quyết',
  'tp.sla.stopsSla': 'Dừng SLA',
  'tp.thread.empty': 'Chưa có gì được gửi. Tin nhắn đầu tiên của bạn sẽ bắt đầu luồng riêng tư này.',
  'tp.thread.messageFailed': 'Tin nhắn không gửi được',
  'tp.thread.privateThread': 'Luồng riêng tư',
  'tp.thread.replyPlaceholder': 'Trả lời trong luồng…',
  'tp.thread.someone': 'Ai đó',
  'tp.thread.startPrivateThread': 'Bắt đầu một luồng riêng tư',
  'tp.thread.startedBy': '{name} đã bắt đầu luồng này',
  'tp.thread.unableToSend': 'Không thể gửi tin nhắn',
  'tp.ui.breadcrumb': 'Đường dẫn',
  'tp.ui.closePanel': 'Đóng bảng',
  'tp.ui.dismiss': 'Bỏ qua {title}',

  'dir.loadError': 'Không thể tải dữ liệu. Vui lòng thử lại.',
  'dir.contacts.description': 'Các liên hệ khách hàng và lịch sử hỗ trợ của họ.',
  'dir.contacts.searchAria': 'Tìm kiếm liên hệ',
  'dir.contacts.count': '{count} liên hệ',
  'dir.contacts.noMatch': 'Không có liên hệ nào khớp với tìm kiếm này',
  'dir.contacts.none': 'Chưa có liên hệ nào',
  'dir.contacts.noneDescription': 'Các liên hệ sẽ xuất hiện ở đây khi khách hàng bắt đầu gửi ticket.',
  'dir.company': 'Công ty',
  'dir.unnamedContact': 'Liên hệ chưa đặt tên',
  'dir.contact': 'Liên hệ',
  'dir.contactNotFound': 'Không tìm thấy liên hệ.',
  'dir.confirmDeleteContactTitle': 'Xóa “{name}”?',
  'dir.thisContact': 'liên hệ này',
  'dir.confirmDeleteContactDescription': 'Các liên hệ có ticket sẽ bị vô hiệu hóa thay vì xóa vĩnh viễn.',
  'dir.deleteContact': 'Xóa liên hệ',
  'dir.editProfile': 'Chỉnh sửa hồ sơ',
  'dir.profile': 'Hồ sơ',
  'dir.firstName': 'Tên',
  'dir.lastName': 'Họ',
  'dir.phone': 'Điện thoại',
  'dir.timezone': 'Múi giờ',
  'dir.emailLabel': 'Email:',
  'dir.phoneLabel': 'Điện thoại:',
  'dir.companyLabel': 'Công ty:',
  'dir.timezoneLabel': 'Múi giờ:',
  'dir.recentTickets': 'Ticket gần đây',
  'dir.noTicketsYet': 'Chưa có ticket nào',
  'dir.contactTicketsDescription': 'Các ticket do liên hệ này tạo sẽ được liệt kê ở đây.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Chủ đề',
  'dir.status': 'Trạng thái',
  'dir.created': 'Đã tạo',
  'dir.companies.description': 'Các tổ chức được liên kết với liên hệ và ticket của khách hàng.',
  'dir.companies.add': 'Thêm công ty',
  'dir.companies.domain': 'Tên miền',
  'dir.companies.create': 'Tạo công ty',
  'dir.companies.searchAria': 'Tìm kiếm công ty',
  'dir.companies.searchPlaceholder': 'Tìm công ty hoặc tên miền',
  'dir.companies.noMatch': 'Không có công ty nào khớp với tìm kiếm này',
  'dir.companies.addFirst': 'Thêm công ty đầu tiên của bạn',
  'dir.companies.tryDifferent': 'Hãy thử tên công ty hoặc tên miền khác.',
  'dir.companies.useForm': 'Dùng biểu mẫu bên cạnh danh sách này để tạo công ty.',
  'dir.companies.contacts': 'Liên hệ',
  'dir.companies.tickets': 'Ticket',
  'dir.companies.notFound': 'Không tìm thấy công ty.',
  'dir.companies.confirmDeleteTitle': 'Xóa “{name}”?',
  'dir.companies.thisCompany': 'công ty này',
  'dir.companies.confirmDeleteDescription': 'Công ty phải không còn liên hệ hoặc ticket nào thì mới có thể xóa.',
  'dir.companies.delete': 'Xóa công ty',
  'dir.companies.noDomain': 'Chưa cấu hình tên miền',
  'dir.companies.contactsCount': 'Liên hệ ({count})',
  'dir.companies.ticketsCount': 'Ticket ({count})',
  'dir.companies.noContactsDescription': 'Thêm một liên hệ và liên kết với công ty này để hiển thị ở đây.',
  'dir.companies.noTicketsDescription': 'Các ticket do liên hệ của công ty này tạo sẽ được liệt kê ở đây.',
  'dir.trendsCreatedHour': 'Ngày tạo - Giờ trong ngày',
  'dir.reports.loadError': 'Không thể tải báo cáo này. Vui lòng thử lại.',
  'dir.reports.volume': 'Khối lượng ticket',
  'dir.reports.sla': 'Tuân thủ SLA',
  'dir.reports.agents': 'Hiệu suất agent',
  'dir.reports.csat': 'Mức độ hài lòng của khách hàng',
  'dir.reports.rca': 'Phân tích nguyên nhân gốc',
  'dir.reports.descVolume': 'Xem ticket đến từ đâu và di chuyển qua vòng đời như thế nào.',
  'dir.reports.descSla': 'Theo dõi mục tiêu phản hồi và giải quyết trên toàn bộ hoạt động hỗ trợ có thể truy cập.',
  'dir.reports.descAgents': 'So sánh khối lượng công việc, kết quả, phản hồi và thời gian xử lý trung bình theo agent.',
  'dir.reports.descCsat': 'Đọc cảm nhận của khách hàng mà không nhầm lẫn khối lượng phản hồi với tỷ lệ hài lòng.',
  'dir.reports.descRca': 'Tìm các nguyên nhân gốc được chuẩn hóa đằng sau nhu cầu ticket.',
  'dir.reports.noPayload': 'Không có dữ liệu báo cáo nào được trả về cho giai đoạn này.',
  'dir.reports.refresh': 'Làm mới',
  'dir.reports.report': 'Báo cáo',
  'dir.reports.from': 'Từ',
  'dir.reports.to': 'Đến',
  'dir.reports.maxRange': 'Phạm vi tối đa: 90 ngày · phạm vi theo quyền của tài khoản bạn.',
  'dir.reports.unclassified': 'Chưa phân loại',
  'dir.reports.ticketsInPeriod': 'Ticket trong giai đoạn',
  'dir.reports.ticketsInPeriodDetail': 'Các ticket có thể truy cập do báo cáo trả về',
  'dir.reports.created': 'Đã tạo',
  'dir.reports.createdDetail': 'Trên trục ngày đã chọn',
  'dir.reports.resolved': 'Đã giải quyết',
  'dir.reports.resolvedDetail': '{percent}% khối lượng đã tạo',
  'dir.reports.noCreated': 'Không có ticket nào được tạo',
  'dir.reports.reopened': 'Đã mở lại',
  'dir.reports.reopenedDetail': 'Sự kiện vòng đời, không phải ticket duy nhất',
  'dir.reports.dailyPulse': 'Nhịp hằng ngày',
  'dir.reports.volumeByDate': 'Khối lượng ticket theo ngày',
  'dir.reports.volumeByDateDescription': 'Các hàng thưa từ backend được mở rộng thành trục ngày đầy đủ, điền số 0.',
  'dir.reports.createdTickets': 'Ticket đã tạo',
  'dir.reports.createdVolumeAria': 'Khối lượng ticket đã tạo theo ngày',
  'dir.reports.lifecycle': 'Vòng đời',
  'dir.reports.lifecycleTitle': 'Đã tạo, đã giải quyết, đã mở lại',
  'dir.reports.lifecycleDescription': 'Góc nhìn ba đường về sự chuyển động qua vòng đời ticket.',
  'dir.reports.lifecycleAria': 'Sự kiện vòng đời ticket theo ngày',
  'dir.reports.dimensions': 'Chiều dữ liệu',
  'dir.reports.whereConcentrated': 'Nơi khối lượng tập trung',
  'dir.reports.topEight': 'Hiển thị tám phân đoạn hàng đầu cho mỗi bảng',
  'dir.reports.status': 'Trạng thái',
  'dir.reports.statusDescription': 'Trạng thái ticket hiện tại',
  'dir.reports.priority': 'Mức độ ưu tiên',
  'dir.reports.priorityDescription': 'Cơ cấu mức độ ưu tiên của ticket',
  'dir.reports.group': 'Nhóm',
  'dir.reports.groupDescription': 'Nhóm định tuyến',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Người phụ trách được giao',
  'dir.reports.product': 'Sản phẩm',
  'dir.reports.productDescription': 'Cơ cấu sản phẩm',
  'dir.reports.country': 'Quốc gia',
  'dir.reports.countryDescription': 'Từ các trường quốc gia được chuẩn hóa',
  'dir.reports.noRecords': 'Không có bản ghi nào trong giai đoạn này.',
  'dir.reports.slaSummary': '{rate} · đạt {met}/{total}',
  'dir.reports.noSlaSegments': 'Chưa có phân đoạn SLA',
  'dir.reports.noSlaSegmentsDescription': 'Không có bản ghi SLA áp dụng cho chiều này trong giai đoạn đã chọn.',
  'dir.reports.segment': 'Phân đoạn',
  'dir.reports.firstResponse': 'Phản hồi đầu tiên',
  'dir.reports.resolution': 'Giải quyết',
  'dir.reports.avgFirstResponse': 'Phản hồi đầu tiên TB',
  'dir.reports.avgResolution': 'Giải quyết TB',
  'dir.reports.fromTicketMetric': 'Từ TicketMetric',
  'dir.reports.slaLens': 'Góc nhìn SLA',
  'dir.reports.performanceBySegment': 'Hiệu suất theo phân đoạn',
  'dir.reports.slaRatesNote': 'Tỷ lệ chỉ tính các bản ghi có mục tiêu SLA áp dụng. Thời lượng là thời gian trôi qua trung bình.',
  'dir.reports.slaDimensionAria': 'Chiều phân tích SLA',
  'dir.reports.rosterSignal': 'Tín hiệu đội ngũ',
  'dir.reports.agentPerformance': 'Hiệu suất agent',
  'dir.reports.agentPerformanceDescription': 'Mọi agent đang hoạt động đều được đưa vào, kể cả agent chưa có hoạt động nào.',
  'dir.reports.filterAgentsAria': 'Lọc agent',
  'dir.reports.filterAgentsPlaceholder': 'Lọc theo agent hoặc email',
  'dir.reports.matchingAgents': '{count} agent khớp',
  'dir.reports.activeAgents': '{count} agent đang hoạt động',
  'dir.reports.sortedBy': 'sắp xếp theo {key} {direction}',
  'dir.reports.asc': 'tăng dần',
  'dir.reports.desc': 'giảm dần',
  'dir.reports.noAgentsMatch': 'Không có agent nào khớp với bộ lọc này',
  'dir.reports.assigned': 'Đã phân công',
  'dir.reports.replies': 'Phản hồi',
  'dir.reports.csatScore': 'Điểm CSAT',
  'dir.reports.csatScoreDetail': 'Đánh giá 4 hoặc 5',
  'dir.reports.averageRating': 'Đánh giá trung bình',
  'dir.reports.averageRatingDetail': 'Trên các khảo sát đã đánh giá',
  'dir.reports.ratedSurveys': 'Khảo sát đã đánh giá',
  'dir.reports.ratedSurveysDetail': 'Trong giai đoạn đã chọn',
  'dir.reports.satisfied': 'Hài lòng',
  'dir.reports.satisfiedDetail': 'Phản hồi tích cực',
  'dir.reports.responseTrend': 'Xu hướng phản hồi',
  'dir.reports.surveyVolume': 'Số lượng khảo sát theo ngày',
  'dir.reports.surveyVolumeDescription': 'Backend trả về số phản hồi theo ngày; đây không phải điểm số hằng ngày. 100 phản hồi mới nhất được lấy mẫu bên dưới.',
  'dir.reports.surveyResponses': 'Phản hồi khảo sát',
  'dir.reports.surveyVolumeAria': 'Số lượng phản hồi khảo sát CSAT theo ngày',
  'dir.reports.responsesByGroup': 'Phản hồi theo nhóm',
  'dir.reports.responsesByGroupDescription': 'Số phản hồi khảo sát, không phải tỷ lệ hài lòng của nhóm',
  'dir.reports.responsesByAgent': 'Phản hồi theo agent',
  'dir.reports.responsesByAgentDescription': 'Số phản hồi khảo sát, không phải tỷ lệ hài lòng của agent',
  'dir.reports.customerVoice': 'Tiếng nói khách hàng',
  'dir.reports.latestSurveys': 'Phản hồi khảo sát mới nhất',
  'dir.reports.boundedSample': 'Mẫu giới hạn · {count}/tối đa 100',
  'dir.reports.latestSurveysNote': 'Các phản hồi mới nhất do API báo cáo trả về. Dùng bảng này để xem nhanh, không phải bản xuất đầy đủ.',
  'dir.reports.noSurveys': 'Không có phản hồi khảo sát',
  'dir.reports.noSurveysDescription': 'Phản hồi CSAT sẽ xuất hiện ở đây khi khách hàng đánh giá ticket đã giải quyết.',
  'dir.reports.rating': 'Đánh giá',
  'dir.reports.comment': 'Nhận xét',
  'dir.reports.received': 'Đã nhận',
  'dir.reports.ratingOutOf': '{rating}/5',
  'dir.reports.noComment': 'Không có nhận xét',
  'dir.reports.rcaEyebrow': 'Phân tích nguyên nhân gốc',
  'dir.reports.rcaTitle': 'Vì sao ticket được tạo',
  'dir.reports.rcaDescription': 'Danh mục và danh mục con là các tổng hợp độc lập từ các trường tùy chỉnh ticket đã chuẩn hóa.',
  'dir.reports.rcaDimensionAria': 'Chiều RCA',
  'dir.reports.category': 'Danh mục',
  'dir.reports.subcategory': 'Danh mục con',
  'dir.reports.rcaEmpty': 'Không có giá trị nguyên nhân gốc nào được ghi nhận trong giai đoạn này.',
  'dir.kb.articleLoadError': 'Không thể tải bài viết.',
  'dir.kb.articleNotFound': 'Không tìm thấy bài viết.',
  'dir.kb.retry': 'Thử lại',
  'dir.kb.title': 'Cơ sở kiến thức',
  'dir.kb.breadcrumb': 'Cơ sở kiến thức',
  'dir.kb.description': '{articles} bài viết trong {folders} thư mục',
  'dir.kb.newArticle': 'Bài viết mới',
  'dir.kb.editArticle': 'Chỉnh sửa bài viết',
  'dir.kb.sectionsAria': 'Các mục cơ sở kiến thức',
  'dir.kb.tabArticles': 'Bài viết',
  'dir.kb.tabStructure': 'Danh mục & thư mục',
  'dir.kb.folderFilterAria': 'Bộ lọc thư mục',
  'dir.kb.allArticles': 'Tất cả bài viết ({count})',
  'dir.kb.writeFirst': 'Viết bài viết đầu tiên của bạn',
  'dir.kb.writeFirstDescription': 'Dùng Bài viết mới để thêm nội dung vào thư mục này.',
  'dir.kb.byAuthor': 'bởi {name}',
  'dir.kb.views': '{count} lượt xem',
  'dir.kb.published': 'Đã xuất bản',
  'dir.kb.draft': 'Bản nháp',
  'dir.kb.publish': 'Xuất bản',
  'dir.kb.unpublish': 'Hủy xuất bản',
  'dir.kb.noFolders': 'Không có thư mục nào trong danh mục này',
  'dir.kb.noFoldersDescription': 'Thêm một thư mục để bắt đầu nhóm các bài viết.',
  'dir.kb.articlesCount': '{count} bài viết',
  'dir.kb.fieldTitle': 'Tiêu đề',
  'dir.kb.folder': 'Thư mục',
  'dir.kb.selectFolder': 'Chọn thư mục',
  'dir.kb.content': 'Nội dung',
  'dir.kb.contentPlaceholder': 'Viết nội dung bài viết của bạn...',
  'dir.kb.tags': 'Thẻ (phân tách bằng dấu phẩy)',
  'dir.kb.attachments': 'Tệp đính kèm',
  'dir.kb.download': 'Tải xuống',
  'dir.kb.downloadFile': 'Tải xuống {name}',
  'dir.kb.remove': 'Xóa',
  'dir.kb.removeFile': 'Xóa {name}',
  'dir.kb.noAttachments': 'Chưa có tệp đính kèm.',
  'dir.kb.uploadAria': 'Tải lên tệp đính kèm',
  'dir.kb.uploading': 'Đang tải lên...',
  'dir.kb.addFile': 'Thêm tệp',
  'dir.kb.confirmDeleteTitle': 'Xóa bài viết?',
  'dir.kb.confirmDeleteDescription': 'Bài viết đã xuất bản hoặc bản nháp này sẽ bị xóa vĩnh viễn.',
  'dir.kb.confirmDeleteLabel': 'Xóa bài viết',
  'dir.kb.confirmRemoveTitle': 'Xóa tệp đính kèm?',
  'dir.kb.confirmRemoveDescription': 'Tệp sẽ bị xóa vĩnh viễn khỏi bài viết này.',
  'dir.kb.confirmRemoveLabel': 'Xóa tệp đính kèm',
  'dir.reports.rangeInvalid': 'Hãy chọn ngày bắt đầu và ngày kết thúc hợp lệ.',
  'dir.reports.rangeOrder': 'Ngày kết thúc phải bằng hoặc sau ngày bắt đầu.',
  'dir.reports.rangeMax': 'Báo cáo hỗ trợ phạm vi ngày tối đa là 90 ngày.',

  'adm.active': 'Đang hoạt động',
  'adm.auto.action.add_tag': 'thêm thẻ',
  'adm.auto.action.assign_agent': 'phân công agent',
  'adm.auto.action.assign_group': 'phân công nhóm',
  'adm.auto.action.send_email': 'gửi email',
  'adm.auto.action.send_notification': 'gửi thông báo',
  'adm.auto.action.set_priority': 'đặt mức độ ưu tiên',
  'adm.auto.action.set_status': 'đặt trạng thái',
  'adm.auto.actions': 'Hành động',
  'adm.auto.addAction': '+ Thêm hành động',
  'adm.auto.addCondition': '+ Thêm điều kiện',
  'adm.auto.addRule': 'Thêm quy tắc',
  'adm.auto.colApplied': 'Hành động đã áp dụng',
  'adm.auto.colDate': 'Ngày',
  'adm.auto.colMatched': 'Đã khớp',
  'adm.auto.colSubject': 'Chủ đề',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Điều kiện',
  'adm.auto.confirmDesc': 'Quy tắc này sẽ ngừng chạy ngay lập tức và không thể khôi phục.',
  'adm.auto.confirmLabel': 'Xóa quy tắc',
  'adm.auto.confirmTitle': 'Xóa quy tắc tự động hóa?',
  'adm.auto.countMany': '{count} quy tắc tự động hóa',
  'adm.auto.countOne': '{count} quy tắc tự động hóa',
  'adm.auto.create': 'Tạo',
  'adm.auto.createFirst': 'Tạo quy tắc tự động hóa đầu tiên của bạn',
  'adm.auto.createFirstDesc': 'Dùng Thêm quy tắc để tự động định tuyến, ưu tiên hoặc thông báo.',
  'adm.auto.deleteFailed': 'Xóa không thành công',
  'adm.auto.description': 'Các quy tắc chạy tuần tự theo vị trí. Các điều kiện trong một quy tắc được kết hợp bằng AND.',
  'adm.auto.editRule': 'Chỉnh sửa quy tắc tự động hóa',
  'adm.auto.execFailed': 'Không thể tải các lần thực thi',
  'adm.auto.field.assigneeId': 'người được giao',
  'adm.auto.field.companyId': 'công ty',
  'adm.auto.field.groupId': 'nhóm',
  'adm.auto.field.priority': 'mức độ ưu tiên',
  'adm.auto.field.requesterId': 'người yêu cầu',
  'adm.auto.field.source': 'nguồn',
  'adm.auto.field.status': 'trạng thái',
  'adm.auto.field.subject': 'chủ đề',
  'adm.auto.field.ticketTypeId': 'loại ticket',
  'adm.auto.hits': 'Lượt khớp',
  'adm.auto.loadFailed': 'Không thể tải các quy tắc tự động hóa',
  'adm.auto.log': 'Nhật ký',
  'adm.auto.logTitle': 'Nhật ký thực thi — {name}',
  'adm.auto.moveDown': 'Di chuyển xuống',
  'adm.auto.moveUp': 'Di chuyển lên',
  'adm.auto.newRule': 'Quy tắc tự động hóa mới',
  'adm.auto.no': 'Không',
  'adm.auto.noRuns': 'Chưa ghi nhận lần chạy nào',
  'adm.auto.noRunsDesc': 'Các lần thực thi sẽ xuất hiện ở đây khi quy tắc này khớp với một ticket lần đầu tiên.',
  'adm.auto.op.contains': 'chứa',
  'adm.auto.op.ends_with': 'kết thúc bằng',
  'adm.auto.op.greater_than': 'lớn hơn',
  'adm.auto.op.in': 'nằm trong',
  'adm.auto.op.is': 'là',
  'adm.auto.op.is_empty': 'trống',
  'adm.auto.op.is_not': 'không phải',
  'adm.auto.op.is_not_empty': 'không trống',
  'adm.auto.op.less_than': 'nhỏ hơn',
  'adm.auto.op.not_contains': 'không chứa',
  'adm.auto.op.not_in': 'không nằm trong',
  'adm.auto.op.starts_with': 'bắt đầu bằng',
  'adm.auto.reorderFailed': 'Sắp xếp lại không thành công',
  'adm.auto.saveFailed': 'Lưu không thành công',
  'adm.auto.stopProcessing': 'Dừng xử lý các quy tắc tiếp theo',
  'adm.auto.title': 'Quy tắc tự động hóa',
  'adm.auto.toggleFailed': 'Chuyển đổi không thành công',
  'adm.auto.trigger': 'Kích hoạt *',
  'adm.auto.trigger.ticket_creation': 'Tạo ticket',
  'adm.auto.trigger.ticket_update': 'Cập nhật ticket',
  'adm.auto.trigger.time_trigger': 'Theo thời gian',
  'adm.auto.triggerCol': 'Kích hoạt',
  'adm.auto.valuePlaceholder': 'Giá trị',
  'adm.auto.yes': 'Có',
  'adm.close': 'Đóng',
  'adm.deleting': 'Đang xóa...',
  'adm.description': 'Mô tả',
  'adm.descriptionLabel': 'Mô tả',
  'adm.edit': 'Chỉnh sửa',
  'adm.email.addChannel': 'Thêm kênh',
  'adm.email.addTitle': 'Thêm kênh email',
  'adm.email.colEmail': 'Email',
  'adm.email.colReplyTo': 'Reply-to',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Kênh này sẽ không còn khả dụng cho thư hỗ trợ.',
  'adm.email.confirmLabel': 'Xóa kênh',
  'adm.email.confirmTitle': 'Xóa kênh email?',
  'adm.email.countMany': '{count} kênh email',
  'adm.email.countOne': '{count} kênh email',
  'adm.email.create': 'Tạo',
  'adm.email.createFirst': 'Thêm kênh email đầu tiên của bạn',
  'adm.email.createFirstDesc': 'Dùng Thêm kênh để kết nối một địa chỉ hỗ trợ để các phản hồi đến được trung tâm này.',
  'adm.email.default': 'Mặc định',
  'adm.email.defaultChannel': 'Kênh mặc định',
  'adm.email.deleteFailed': 'Xóa không thành công',
  'adm.email.description': 'Quản lý địa chỉ email đến/đi, cấu hình SMTP và cài đặt reply-to.',
  'adm.email.editTitle': 'Chỉnh sửa kênh email',
  'adm.email.emailAddress': 'Địa chỉ email *',
  'adm.email.loadFailed': 'Không thể tải cấu hình email',
  'adm.email.outbound': 'SMTP gửi đi',
  'adm.email.replyTo': 'Địa chỉ reply-to',
  'adm.email.replyToPh': '(mặc định là địa chỉ email)',
  'adm.email.saveFailed': 'Lưu không thành công',
  'adm.email.sesGlobal': 'SES (toàn cục)',
  'adm.email.smtpHost': 'Máy chủ SMTP',
  'adm.email.smtpHostPh': 'ví dụ: email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Mật khẩu SMTP',
  'adm.email.smtpPort': 'Cổng SMTP',
  'adm.email.smtpUser': 'Người dùng SMTP',
  'adm.email.title': 'Kênh email',
  'adm.groups.aboutBody': 'Thành viên quyết định agent nào xem ticket của nhóm này theo mặc định. Giờ làm việc quy định thời gian SLA cho các ticket được định tuyến đến đây, và người liên hệ leo thang sẽ được thông báo cùng với người được giao khi ticket vi phạm SLA.',
  'adm.groups.aboutTitle': 'Giới thiệu về nhóm này',
  'adm.groups.accountDefault': 'Mặc định của tài khoản',
  'adm.groups.activeAgentMany': '{count} agent đang hoạt động',
  'adm.groups.activeAgentOne': '{count} agent đang hoạt động',
  'adm.groups.activeAgents': 'Agent đang hoạt động',
  'adm.groups.addMember': 'Thêm thành viên',
  'adm.groups.assignment': 'Phân công',
  'adm.groups.autoAssign': 'Phân công tự động',
  'adm.groups.autoAssignNote': 'Việc phân công ticket trong sản phẩm này luôn là thủ công - không có định tuyến vòng tròn hay theo tải. Nút chuyển này không thay đổi điều đó.',
  'adm.groups.businessHours': 'Giờ làm việc',
  'adm.groups.colGroup': 'Nhóm',
  'adm.groups.confirmDesc': 'Phải phân công lại các ticket và mẫu đang dùng nhóm này trước.',
  'adm.groups.confirmLabel': 'Xóa nhóm',
  'adm.groups.confirmTitle': 'Xóa “{name}”?',
  'adm.groups.createFirst': 'Tạo nhóm đầu tiên của bạn',
  'adm.groups.defaultHours': 'Giờ mặc định',
  'adm.groups.editAria': 'Chỉnh sửa {name}',
  'adm.groups.editGroup': 'Chỉnh sửa nhóm',
  'adm.groups.escalateHelp': 'Được thêm làm người nhận thông báo khi một ticket trong nhóm này vi phạm SLA.',
  'adm.groups.escalateTo': 'Leo thang đến',
  'adm.groups.escalatesTo': 'Leo thang đến',
  'adm.groups.escalatesToName': 'Leo thang đến {name}',
  'adm.groups.escalationBody': 'Khi một ticket trong nhóm này vi phạm SLA, người liên hệ leo thang được thêm làm người nhận thông báo cùng với người được giao và các thành viên nhóm.',
  'adm.groups.escalationTitle': 'Người liên hệ leo thang',
  'adm.groups.hoursHelp': 'Dùng để tính SLA cho các ticket trong nhóm này.',
  'adm.groups.manageAgents': 'Quản lý agent',
  'adm.groups.manageHours': 'Quản lý giờ làm việc',
  'adm.groups.manual': 'Thủ công',
  'adm.groups.manualBody': 'Việc phân công trong sản phẩm này là thủ công - không có tự động phân công vòng tròn hay theo tải. Nút chuyển "Phân công tự động" của nhóm chỉ ảnh hưởng đến việc ticket mới trong nhóm đó mặc định chưa được phân công hay dùng quy tắc định tuyến hiện có; các agent vẫn tự nhận và bàn giao ticket.',
  'adm.groups.manualTitle': 'Phân công thủ công',
  'adm.groups.memberMany': '{count} thành viên',
  'adm.groups.memberOne': '{count} thành viên',
  'adm.groups.members': 'Thành viên',
  'adm.groups.newGroup': 'Nhóm mới',
  'adm.groups.noEscalation': 'Không có người liên hệ leo thang',
  'adm.groups.noMatch': 'Không có nhóm nào khớp với tìm kiếm này',
  'adm.groups.noMembers': 'Chưa có thành viên',
  'adm.groups.noMembersDesc': 'Chọn một agent đang hoạt động ở trên rồi chọn Thêm thành viên.',
  'adm.groups.remove': 'Xóa',
  'adm.groups.routing': 'Định tuyến',
  'adm.groups.routingMethod': 'Phương thức định tuyến',
  'adm.groups.saved': 'Đã lưu nhóm.',
  'adm.groups.searchAria': 'Tìm kiếm nhóm',
  'adm.groups.searchPlaceholder': 'Tìm theo tên',
  'adm.groups.selectActiveAgent': 'Chọn agent đang hoạt động',
  'adm.groups.showing': 'Hiển thị {start}-{end} trong {total}',
  'adm.groups.subtitle': 'Nhóm kiểm soát việc định tuyến và hiển thị ticket. Phân công agent làm thành viên, và chọn lịch giờ làm việc cùng người liên hệ leo thang cho từng nhóm.',
  'adm.groups.title': 'Nhóm',
  'adm.groups.tryDifferent': 'Hãy thử tên nhóm khác.',
  'adm.groups.unassigned': 'Chưa phân công',
  'adm.groups.useNew': 'Dùng Nhóm mới để định tuyến ticket đến một tập hợp agent.',
  'adm.groups.zero': '0 nhóm',
  'adm.inactive': 'Không hoạt động',
  'adm.jira.accepted': 'Kết nối đã được chấp nhận',
  'adm.jira.accountEmail': 'Email tài khoản Jira',
  'adm.jira.accountEmailLabel': 'Email tài khoản',
  'adm.jira.activeConn': 'Kết nối đang hoạt động',
  'adm.jira.addConnection': 'Thêm kết nối',
  'adm.jira.addTitle': 'Thêm kết nối Jira',
  'adm.jira.added': 'Đã thêm kết nối Jira',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Xóa webhook secret đã lưu',
  'adm.jira.confirmDesc': 'Thao tác này xóa kết nối đã lưu và các liên kết ticket của nó. Các issue Jira không bị xóa.',
  'adm.jira.confirmLabel': 'Xóa kết nối',
  'adm.jira.confirmTitle': 'Xóa {name}?',
  'adm.jira.connName': 'Tên kết nối',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Đã kết nối với tư cách {name}',
  'adm.jira.connectionDesk': 'Bàn kết nối',
  'adm.jira.default': 'Mặc định',
  'adm.jira.defaultConn': 'Kết nối mặc định',
  'adm.jira.defaultIssueType': 'Loại issue mặc định',
  'adm.jira.defaultProjectKey': 'Khóa dự án mặc định',
  'adm.jira.defaults': 'Mặc định',
  'adm.jira.description': 'Kết nối các trang Jira thuộc tài khoản để agent có thể liên kết issue và giữ trạng thái ticket đồng bộ.',
  'adm.jira.editTitle': 'Chỉnh sửa kết nối Jira',
  'adm.jira.footer': 'Tạo webhook Jira với endpoint hiển thị ở trên, đăng ký sự kiện issue updated, và dùng cùng webhook secret đã cấu hình ở đây.',
  'adm.jira.heading': 'Giữ bộ phận hỗ trợ và kỹ thuật trong cùng một vòng lặp',
  'adm.jira.intro': 'Thông tin xác thực được lưu mã hóa trên máy chủ và không bao giờ được trả về màn hình này. Hãy cấu hình webhook secret khi Jira cần gửi thay đổi trạng thái về SuzukiDesk.',
  'adm.jira.no': 'Không',
  'adm.jira.noConns': 'Chưa có kết nối Jira nào',
  'adm.jira.noConnsDesc': 'Thêm một kết nối để có các hành động Jira trong chi tiết ticket.',
  'adm.jira.noProject': 'Không có dự án',
  'adm.jira.pasteToken': 'Dán token',
  'adm.jira.requestFailed': 'Yêu cầu Jira không thành công. Vui lòng thử lại.',
  'adm.jira.savedToast': 'Đã lưu kết nối Jira',
  'adm.jira.secretConfigured': 'Đã cấu hình secret: {value}',
  'adm.jira.secretHint': 'Dùng cùng secret này khi tạo webhook Jira.',
  'adm.jira.secretOptional': 'Không bắt buộc, từ 16 ký tự trở lên',
  'adm.jira.siteUrl': 'URL trang Jira',
  'adm.jira.siteUrlHint': 'Không đưa thông tin xác thực vào URL.',
  'adm.jira.syncFromJira': 'Trạng thái Jira về ticket',
  'adm.jira.syncSnapshot': 'Ảnh chụp issue đã liên kết',
  'adm.jira.syncToJira': 'Trạng thái ticket sang Jira',
  'adm.jira.testConnection': 'Kiểm tra kết nối',
  'adm.jira.testFailed': 'Kiểm tra kết nối không thành công',
  'adm.jira.title': 'Tích hợp Jira',
  'adm.jira.tokenHintEdit': 'Để trống để giữ token hiện tại.',
  'adm.jira.tokenHintNew': 'Được lưu mã hóa; sẽ không hiển thị lại.',
  'adm.jira.tokenMissing': 'Thiếu token API',
  'adm.jira.tokenStored': 'Đã lưu token API',
  'adm.jira.unchanged': '(không đổi nếu để trống)',
  'adm.jira.verified': 'Đã xác minh kết nối Jira',
  'adm.jira.webhookEndpoint': 'Endpoint webhook Jira',
  'adm.jira.webhookSecret': 'Webhook secret',
  'adm.jira.whatSyncs': 'Nội dung được đồng bộ',
  'adm.jira.yes': 'Có',
  'adm.nameRequired': 'Tên *',
  'adm.nextPage': 'Trang tiếp theo',
  'adm.notif.aud.all': 'Dùng chung',
  'adm.notif.aud.customer': 'Khách hàng',
  'adm.notif.aud.internal': 'Nội bộ',
  'adm.notif.audEmail': 'Email {audience}',
  'adm.notif.body': 'Nội dung',
  'adm.notif.description': 'Tùy chỉnh thông báo cho từng đối tượng mà không đưa khách hàng vào không gian làm việc nội bộ.',
  'adm.notif.discardDesc': 'Các thay đổi chưa lưu của mẫu thông báo này sẽ bị mất nếu bạn chuyển sang mẫu khác.',
  'adm.notif.discardLabel': 'Bỏ thay đổi',
  'adm.notif.discardTitle': 'Bỏ các thay đổi chưa lưu?',
  'adm.notif.discarded': 'Đã bỏ các thay đổi chưa lưu.',
  'adm.notif.event.automation_notification': 'Thông báo tự động hóa',
  'adm.notif.event.group_member_added': 'Được thêm vào nhóm',
  'adm.notif.event.mention': 'Đề cập',
  'adm.notif.event.pending_input': 'Đang chờ phản hồi',
  'adm.notif.event.sla_breach': 'Vi phạm SLA',
  'adm.notif.event.sla_escalation': 'Leo thang SLA',
  'adm.notif.event.sla_warning': 'Cảnh báo SLA',
  'adm.notif.event.ticket_assigned': 'Ticket được phân công',
  'adm.notif.event.ticket_created': 'Ticket đã được tạo',
  'adm.notif.event.ticket_first_response': 'Phản hồi đầu tiên',
  'adm.notif.event.ticket_group_assigned': 'Ticket được phân công cho nhóm',
  'adm.notif.event.ticket_note': 'Ghi chú riêng tư',
  'adm.notif.event.ticket_public_note': 'Ghi chú công khai',
  'adm.notif.event.ticket_reply': 'Phản hồi ticket',
  'adm.notif.event.ticket_resolved': 'Ticket đã được giải quyết',
  'adm.notif.events': 'Sự kiện',
  'adm.notif.eventsHelp': 'Chọn một sự kiện và đối tượng nhận.',
  'adm.notif.insertVar': 'Chèn {variable}',
  'adm.notif.linkNoteAgent': 'Biến liên kết theo đối tượng {variable} mở không gian làm việc của agent cho email này.',
  'adm.notif.linkNoteCustomer': 'Biến liên kết theo đối tượng {variable} mở cổng thông tin khách hàng cho email này.',
  'adm.notif.off': 'tắt',
  'adm.notif.preview': 'Xem trước',
  'adm.notif.previewNotice': 'Bản xem trước được hiển thị với dữ liệu mẫu.',
  'adm.notif.rendering': 'Đang hiển thị…',
  'adm.notif.route.all': 'Dùng liên kết ticket theo người nhận cho đối tượng được gửi.',
  'adm.notif.route.customer': 'Hành động chính mở ticket trên cổng thông tin khách hàng.',
  'adm.notif.route.internal': 'Hành động chính mở ticket trong không gian làm việc của agent.',
  'adm.notif.sampleOnlyAgent': 'Chỉ là dữ liệu mẫu — hành động chính dẫn đến đường dẫn không gian làm việc của agent.',
  'adm.notif.sampleOnlyCustomer': 'Chỉ là dữ liệu mẫu — hành động chính dẫn đến đường dẫn cổng thông tin khách hàng.',
  'adm.notif.saveChanges': 'Lưu thay đổi',
  'adm.notif.saved': 'Đã lưu mẫu.',
  'adm.notif.savedBtn': 'Đã lưu',
  'adm.notif.selectEvent': 'Chọn một sự kiện để chỉnh sửa mẫu của nó',
  'adm.notif.selectEventDesc': 'Chọn một sự kiện thông báo ở bên trái để thay đổi tiêu đề và nội dung.',
  'adm.notif.sendTest': 'Gửi email thử',
  'adm.notif.sending': 'Đang gửi…',
  'adm.notif.subject': 'Chủ đề',
  'adm.notif.testQueued': 'Email thử đã được xếp hàng gửi đến {email}.',
  'adm.notif.title': 'Mẫu thông báo',
  'adm.notif.urlVarTitle': 'Biến liên kết theo đối tượng',
  'adm.notif.useTemplate': 'Dùng mẫu này cho đối tượng này',
  'adm.notif.useTemplateHelp': 'Tắt mục này sẽ dùng thông báo dự phòng an toàn.',
  'adm.notif.variables': 'Biến',
  'adm.notif.variablesHelp': 'Nhấp để thêm vào nội dung tin nhắn',
  'adm.pagination': 'Phân trang',
  'adm.perm.cap.admin.label': 'Truy cập bảng điều khiển quản trị',
  'adm.perm.cap.assign.label': 'Phân công ticket',
  'adm.perm.cap.close.label': 'Đóng ticket',
  'adm.perm.cap.conversation_delete.label': 'Xóa phản hồi hoặc ghi chú đã đăng',
  'adm.perm.cap.conversation_edit.label': 'Chỉnh sửa phản hồi hoặc ghi chú đã đăng',
  'adm.perm.cap.create.label': 'Tạo ticket',
  'adm.perm.cap.delete.label': 'Xóa ticket',
  'adm.perm.cap.edit.label': 'Chỉnh sửa thuộc tính ticket',
  'adm.perm.cap.export.label': 'Xuất ticket',
  'adm.perm.cap.field_admin.label': 'Trường ticket',
  'adm.perm.cap.form_admin.label': 'Biểu mẫu ticket',
  'adm.perm.cap.forward.label': 'Chuyển tiếp ticket',
  'adm.perm.cap.jira_link.label': 'Liên kết và quản lý issue Jira',
  'adm.perm.cap.kb.label': 'Truy cập cơ sở kiến thức',
  'adm.perm.cap.manage_agents.label': 'Agent',
  'adm.perm.cap.manage_api_keys.label': 'Khóa API',
  'adm.perm.cap.manage_automations.label': 'Tự động hóa',
  'adm.perm.cap.manage_canned_responses.label': 'Câu trả lời soạn sẵn',
  'adm.perm.cap.manage_email_config.label': 'Email',
  'adm.perm.cap.manage_groups.label': 'Nhóm',
  'adm.perm.cap.manage_jira.label': 'Tích hợp Jira',
  'adm.perm.cap.manage_kb.label': 'Cơ sở kiến thức',
  'adm.perm.cap.manage_notification_templates.label': 'Mẫu thông báo',
  'adm.perm.cap.manage_roles.label': 'Vai trò',
  'adm.perm.cap.manage_tags.label': 'Thẻ',
  'adm.perm.cap.note.label': 'Thêm hoặc chỉnh sửa ghi chú riêng tư',
  'adm.perm.cap.reassign.label': 'Phân công lại ticket đã thuộc về người khác',
  'adm.perm.cap.reopen.label': 'Mở lại ticket đã giải quyết hoặc đã đóng',
  'adm.perm.cap.reply.label': 'Phản hồi công khai cho khách hàng',
  'adm.perm.cap.report_access.label': 'Xem báo cáo và bảng điều khiển',
  'adm.perm.cap.reports.label': 'Truy cập mô-đun báo cáo',
  'adm.perm.cap.resolve.label': 'Giải quyết ticket',
  'adm.perm.cap.settings_admin.label': 'Mở mục Cài đặt (bắt buộc để thấy mục điều hướng Cài đặt và trang chỉ mục của nó; quyền truy cập từng trang bên dưới vẫn được kiểm soát độc lập)',
  'adm.perm.cap.sla_admin.label': 'Chính sách SLA & giờ làm việc',
  'adm.perm.cap.sla_edit.desc': 'Tách biệt với quyền Cài đặt > Chính sách SLA bên dưới — quyền này chỉ áp dụng cho việc chỉnh sửa ngày đến hạn trên từng ticket.',
  'adm.perm.cap.sla_edit.label': 'Ghi đè thủ công ngày đến hạn SLA của ticket',
  'adm.perm.cap.tag.label': 'Quản lý thẻ ticket',
  'adm.perm.cap.thread_start.label': 'Bắt đầu luồng riêng tư trên một mục hội thoại',
  'adm.perm.cap.tickets.label': 'Truy cập không gian làm việc ticket',
  'adm.perm.cap.view.label': 'Xem ticket trong phạm vi',
  'adm.perm.cat.administration.desc': 'Truy cập bảng điều khiển quản trị và các màn hình cấu hình của nó.',
  'adm.perm.cat.administration.label': 'Quản trị',
  'adm.perm.cat.knowledge.desc': 'Đọc và sử dụng nội dung kiến thức khi xử lý ticket.',
  'adm.perm.cat.knowledge.label': 'Cơ sở kiến thức',
  'adm.perm.cat.reporting.desc': 'Báo cáo vận hành và bảng điều khiển.',
  'adm.perm.cat.reporting.label': 'Báo cáo',
  'adm.perm.cat.settings-pages.desc': 'Cấp quyền truy cập từng màn hình Cài đặt riêng lẻ. Không có gì hiển thị cho đến khi được chọn rõ ràng ở đây.',
  'adm.perm.cat.settings-pages.label': 'Các trang Cài đặt',
  'adm.perm.cat.tickets.desc': 'Những gì agent có thể làm trong không gian làm việc ticket.',
  'adm.perm.cat.tickets.label': 'Ticket',
  'adm.previousPage': 'Trang trước',
  'adm.refresh': 'Làm mới',
  'adm.roleType.administrator': 'Quản trị viên',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Cộng tác viên',
  'adm.roleType.customer': 'Khách hàng',
  'adm.roleType.super_admin': 'Siêu quản trị viên',
  'adm.roleType.supervisor': 'Giám sát viên',
  'adm.roles.activeHelp': 'Đang hoạt động - vai trò không hoạt động không thể được gán cho agent',
  'adm.roles.agentCan': 'Agent có thể',
  'adm.roles.agentType': 'Loại agent',
  'adm.roles.agentsAssignedNote': 'Agent được gán vai trò này từ màn hình Agent.',
  'adm.roles.agentsCount': '{count} agent',
  'adm.roles.agentsLabel': 'Agent',
  'adm.roles.agentsManage': '{count} agent - Quản lý',
  'adm.roles.builtIn': '(Tích hợp sẵn)',
  'adm.roles.builtInNote': 'Đây là vai trò tích hợp sẵn. Có thể đổi tên và vô hiệu hóa, nhưng không thể xóa.',
  'adm.roles.builtInTitle': 'Vai trò tích hợp sẵn: có thể chỉnh sửa và vô hiệu hóa, nhưng không thể xóa',
  'adm.roles.categoriesAria': 'Danh mục quyền',
  'adm.roles.confirmDesc': 'Các agent được gán vai trò này sẽ cần một vai trò khác trước khi có thể xóa nó.',
  'adm.roles.confirmLabel': 'Xóa vai trò',
  'adm.roles.createFirst': 'Tạo vai trò đầu tiên của bạn',
  'adm.roles.createFirstDesc': 'Dùng Vai trò mới để xác định các khả năng mà agent sẽ có.',
  'adm.roles.editRole': 'Chỉnh sửa vai trò',
  'adm.roles.granted': 'Đã cấp {count}',
  'adm.roles.heading': 'Vai trò agent',
  'adm.roles.inactive': 'Không hoạt động',
  'adm.roles.newRole': 'Vai trò mới',
  'adm.roles.noAgent': 'Không có agent',
  'adm.roles.notEnforced': '(chưa được áp dụng)',
  'adm.roles.notEnforcedTitle': 'Được lưu trong vai trò nhưng chưa được kiểm soát ở bất kỳ đâu khi chạy',
  'adm.roles.permissions': 'Quyền',
  'adm.roles.saved': 'Đã lưu vai trò.',
  'adm.roles.scopeBody': 'Các khả năng kết hợp với phạm vi cấp hàng (tất cả / nhóm / được giao / của riêng), vì vậy agent chỉ thao tác trên những ticket mà họ vốn đã thấy.',
  'adm.roles.scopeTitle': 'Phạm vi vẫn được áp dụng',
  'adm.roles.scrollTo': 'Cuộn đến',
  'adm.roles.status': 'Trạng thái',
  'adm.roles.subtitle': 'Cung cấp và giới hạn các mức truy cập và đặc quyền chi tiết cho agent.',
  'adm.roles.title': 'Vai trò',
  'adm.roles.typeLocked': 'Không thể thay đổi loại agent sau khi bạn lưu vai trò.',
  'adm.roles.understandingBody1': 'Vai trò quyết định agent có thể làm gì. Tạo một vai trò, chọn các khả năng nó cần cấp, rồi gán cho agent từ màn hình Agent.',
  'adm.roles.understandingBody2': 'Vai trò tích hợp sẵn có thể đổi tên và vô hiệu hóa nhưng không bao giờ xóa được. Vai trò vẫn còn agent được gán cũng không thể xóa, vì vậy hãy chuyển các agent đó trước.',
  'adm.roles.understandingTitle': 'Tìm hiểu về vai trò',
  'adm.saveChanges': 'Lưu thay đổi',
  'adm.settings.add': 'Thêm {name}',
  'adm.settings.back': 'Quay lại cài đặt',
  'adm.settings.cannedDesc': 'Các câu trả lời của tài khoản mà bạn có thể dùng khi xử lý ticket.',
  'adm.settings.cannedEmpty': 'Chưa có câu trả lời soạn sẵn',
  'adm.settings.cannedEmptyDesc': 'Hãy nhờ quản trị viên thêm các câu trả lời dùng chung để nhóm của bạn tái sử dụng trên ticket.',
  'adm.settings.cannedTitle': 'Câu trả lời soạn sẵn',
  'adm.settings.col.autoAssign': 'Tự động phân công',
  'adm.settings.col.color': 'Màu sắc',
  'adm.settings.col.content': 'Nội dung',
  'adm.settings.col.createdAt': 'Tạo lúc',
  'adm.settings.col.description': 'Mô tả',
  'adm.settings.col.email': 'Email',
  'adm.settings.col.expiresAt': 'Hết hạn lúc',
  'adm.settings.col.fieldType': 'Loại trường',
  'adm.settings.col.firstName': 'Tên',
  'adm.settings.col.folderId': 'ID thư mục',
  'adm.settings.col.hitCount': 'Số lượt khớp',
  'adm.settings.col.holidays': 'Ngày nghỉ lễ',
  'adm.settings.col.host': 'Máy chủ',
  'adm.settings.col.hours': 'Giờ',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Đang hoạt động',
  'adm.settings.col.isBuiltIn': 'Tích hợp sẵn',
  'adm.settings.col.isDefault': 'Mặc định',
  'adm.settings.col.isRequired': 'Bắt buộc',
  'adm.settings.col.isShared': 'Dùng chung',
  'adm.settings.col.isSystem': 'Hệ thống',
  'adm.settings.col.key': 'Khóa',
  'adm.settings.col.label': 'Nhãn',
  'adm.settings.col.language': 'Ngôn ngữ',
  'adm.settings.col.lastName': 'Họ',
  'adm.settings.col.lastUsedAt': 'Dùng lần cuối lúc',
  'adm.settings.col.name': 'Tên',
  'adm.settings.col.options': 'Tùy chọn',
  'adm.settings.col.phone': 'Điện thoại',
  'adm.settings.col.port': 'Cổng',
  'adm.settings.col.position': 'Vị trí',
  'adm.settings.col.prefix': 'Tiền tố',
  'adm.settings.col.priority': 'Mức độ ưu tiên',
  'adm.settings.col.required': 'Bắt buộc',
  'adm.settings.col.role': 'Vai trò',
  'adm.settings.col.roleId': 'ID vai trò',
  'adm.settings.col.scopes': 'Phạm vi',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Trạng thái',
  'adm.settings.col.stopProcessing': 'Dừng xử lý',
  'adm.settings.col.timezone': 'Múi giờ',
  'adm.settings.col.title': 'Tiêu đề',
  'adm.settings.col.trigger': 'Kích hoạt',
  'adm.settings.col.type': 'Loại',
  'adm.settings.col.updatedAt': 'Cập nhật lúc',
  'adm.settings.col.usageCount': 'Số lần sử dụng',
  'adm.settings.col.username': 'Tên người dùng',
  'adm.settings.confirmDesc': 'Không thể hoàn tác thao tác này.',
  'adm.settings.confirmTitle': 'Xóa {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Tạo',
  'adm.settings.empty': 'Chưa có {title}',
  'adm.settings.emptyAdd': 'Dùng biểu mẫu ở trên để thêm {name} đầu tiên của bạn.',
  'adm.settings.emptyOther': 'Các mục sẽ xuất hiện ở đây sau khi được cấu hình.',
  'adm.settings.homeDesc': 'Cấu hình người dùng, quy trình ticket, mức dịch vụ và các tích hợp.',
  'adm.settings.manage': 'Quản lý {title}.',
  'adm.settings.noPages': 'Không có trang cài đặt nào khả dụng',
  'adm.settings.noPagesDesc': 'Hãy nhờ siêu quản trị viên cấp quyền truy cập các trang cài đặt bạn cần.',
  'adm.settings.notFound': 'Không tìm thấy trang cài đặt',
  'adm.settings.notFoundDesc': 'Chọn một khu vực cài đặt để tiếp tục.',
  'adm.settings.res.agents.field.email': 'Email',
  'adm.settings.res.agents.field.firstName': 'Tên',
  'adm.settings.res.agents.field.lastName': 'Họ',
  'adm.settings.res.agents.field.password': 'Mật khẩu tạm thời',
  'adm.settings.res.agents.field.roleId': 'ID vai trò',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agent',
  'adm.settings.res.api-keys.field.name': 'Tên khóa',
  'adm.settings.res.api-keys.one': 'khóa API',
  'adm.settings.res.api-keys.title': 'Khóa API',
  'adm.settings.res.automations.field.description': 'Mô tả',
  'adm.settings.res.automations.field.name': 'Tên',
  'adm.settings.res.automations.one': 'tự động hóa',
  'adm.settings.res.automations.title': 'Tự động hóa',
  'adm.settings.res.business-hours.field.name': 'Tên',
  'adm.settings.res.business-hours.field.timezone': 'Múi giờ',
  'adm.settings.res.business-hours.one': 'mục giờ làm việc',
  'adm.settings.res.business-hours.title': 'Giờ làm việc',
  'adm.settings.res.canned-responses.field.content': 'Nội dung câu trả lời',
  'adm.settings.res.canned-responses.field.title': 'Tiêu đề',
  'adm.settings.res.canned-responses.one': 'câu trả lời soạn sẵn',
  'adm.settings.res.canned-responses.title': 'Câu trả lời soạn sẵn',
  'adm.settings.res.email.field.host': 'Máy chủ SMTP',
  'adm.settings.res.email.field.name': 'Tên',
  'adm.settings.res.email.field.port': 'Cổng SMTP',
  'adm.settings.res.email.field.username': 'Tên người dùng',
  'adm.settings.res.email.one': 'cấu hình email',
  'adm.settings.res.email.title': 'Cấu hình email',
  'adm.settings.res.fields.one': 'trường ticket',
  'adm.settings.res.fields.title': 'Trường ticket',
  'adm.settings.res.forms.field.label': 'Nhãn hiển thị',
  'adm.settings.res.forms.field.name': 'Tên trường',
  'adm.settings.res.forms.field.type': 'Loại trường',
  'adm.settings.res.forms.one': 'biểu mẫu hoặc trường tùy chỉnh',
  'adm.settings.res.forms.title': 'Biểu mẫu và trường tùy chỉnh',
  'adm.settings.res.groups.field.description': 'Mô tả',
  'adm.settings.res.groups.field.name': 'Tên',
  'adm.settings.res.groups.one': 'nhóm',
  'adm.settings.res.groups.title': 'Nhóm',
  'adm.settings.res.jira.one': 'tích hợp Jira',
  'adm.settings.res.jira.title': 'Tích hợp Jira',
  'adm.settings.res.kb.field.content': 'Nội dung bài viết',
  'adm.settings.res.kb.field.folderId': 'ID thư mục',
  'adm.settings.res.kb.field.title': 'Tiêu đề bài viết',
  'adm.settings.res.kb.one': 'bài viết cơ sở kiến thức',
  'adm.settings.res.kb.title': 'Quản trị cơ sở kiến thức',
  'adm.settings.res.notification-templates.one': 'mẫu thông báo',
  'adm.settings.res.notification-templates.title': 'Mẫu thông báo',
  'adm.settings.res.roles.field.description': 'Mô tả',
  'adm.settings.res.roles.field.name': 'Tên',
  'adm.settings.res.roles.field.type': 'Loại vai trò',
  'adm.settings.res.roles.one': 'vai trò',
  'adm.settings.res.roles.title': 'Vai trò',
  'adm.settings.res.sla.field.description': 'Mô tả',
  'adm.settings.res.sla.field.name': 'Tên',
  'adm.settings.res.sla.one': 'chính sách SLA',
  'adm.settings.res.sla.title': 'Chính sách SLA',
  'adm.settings.res.tags.field.name': 'Tên',
  'adm.settings.res.tags.one': 'thẻ',
  'adm.settings.res.tags.title': 'Thẻ',
  'adm.settings.title': 'Cài đặt',
  'adm.status': 'Trạng thái',

  'sla.edit': 'Chỉnh sửa',
  'sla.active': 'Đang hoạt động',
  'sla.inactive': 'Không hoạt động',
  'sla.default': 'Mặc định',
  'sla.yes': 'Có',
  'sla.no': 'Không',
  'sla.description': 'Mô tả',
  'sla.status': 'Trạng thái',
  'sla.notConfigured': 'Chưa cấu hình',
  'sla.minutesValue': '{value} phút',
  'sla.invalidServerValue': 'Giá trị máy chủ không hợp lệ',
  'sla.statusSemantics.title': 'Ngữ nghĩa trạng thái ticket',
  'sla.statusSemantics.description': 'Mỗi trạng thái đang hoạt động có một hợp đồng SLA rõ ràng. Trạng thái tạm dừng và trạng thái dừng SLA loại trừ lẫn nhau.',
  'sla.statusSemantics.conflict': 'Một trạng thái không thể vừa tạm dừng SLA vừa dừng SLA.',
  'sla.statusSemantics.emptyTitle': 'Không có định nghĩa trạng thái',
  'sla.statusSemantics.emptyDescription': 'Các định nghĩa trạng thái sẽ xuất hiện ở đây sau khi được cấu hình cho tài khoản này.',
  'sla.statusSemantics.colPauses': 'Tạm dừng SLA',
  'sla.statusSemantics.colStops': 'Dừng SLA',
  'sla.statusSemantics.pausesAria': '{label} tạm dừng SLA',
  'sla.statusSemantics.stopsAria': '{label} dừng SLA',
  'sla.preview.title': 'Xem trước ticket chỉ đọc',
  'sla.preview.description': 'Chạy cùng bộ đánh giá theo phạm vi tài khoản được dùng cho các chu kỳ SLA trực tiếp. Bản xem trước này không bao giờ ghi chính sách hay ticket.',
  'sla.preview.priority': 'Mức độ ưu tiên',
  'sla.preview.group': 'Nhóm',
  'sla.preview.anyGroup': 'Bất kỳ nhóm nào',
  'sla.preview.company': 'Công ty',
  'sla.preview.anyCompany': 'Bất kỳ công ty nào',
  'sla.preview.source': 'Nguồn',
  'sla.preview.anySource': 'Bất kỳ nguồn nào',
  'sla.preview.ticketType': 'Loại ticket',
  'sla.preview.anyTicketType': 'Bất kỳ loại ticket nào',
  'sla.preview.representativeStart': 'Thời điểm bắt đầu đại diện',
  'sla.preview.calculating': 'Đang tính toán…',
  'sla.preview.run': 'Chạy xem trước',
  'sla.preview.configAttention': 'Cấu hình cần được chú ý',
  'sla.preview.selectedPolicy': 'Chính sách đã chọn',
  'sla.preview.noPolicy': 'Không có chính sách',
  'sla.preview.evaluationOrder': 'Thứ tự đánh giá',
  'sla.preview.firstMatching': 'Chính sách khớp đầu tiên',
  'sla.preview.calculationMode': 'Chế độ tính toán',
  'sla.preview.modeBusinessHours': 'Giờ làm việc',
  'sla.preview.modeBusinessHoursNamed': 'Giờ làm việc · {name}',
  'sla.preview.mode247': 'Thời gian trôi qua 24/7',
  'sla.preview.modeNone': 'Không được tính',
  'sla.preview.thresholds': 'Ngưỡng độc lập',
  'sla.preview.colMetric': 'Chỉ số',
  'sla.preview.colTarget': 'Mục tiêu',
  'sla.preview.colWarning': 'Cảnh báo',
  'sla.preview.colDue': 'Hạn / vi phạm',
  'sla.preview.colEscalation': 'Leo thang',
  'sla.preview.colState': 'Trạng thái',
  'sla.preview.metricFirstResponse': 'Phản hồi đầu tiên',
  'sla.preview.metricResolution': 'Giải quyết',
  'sla.preview.trace': 'Dấu vết đánh giá chính sách',
  'sla.preview.selected': 'Đã chọn',
  'sla.preview.matchedAfterSelection': 'Khớp sau khi chọn',
  'sla.preview.skipped': 'Đã bỏ qua',
  'sla.preview.showTrace': 'Hiện dấu vết tính toán',
  'sla.state.not_configured': 'chưa cấu hình',
  'sla.state.running': 'đang chạy',
  'sla.state.paused': 'đã tạm dừng',
  'sla.state.warning': 'cảnh báo',
  'sla.state.breached': 'đã vi phạm',
  'sla.state.met': 'đạt',
  'sla.state.escalated': 'đã leo thang',
  'sla.state.pending': 'đang chờ',
  'sla.state.stopped': 'đã dừng',
  'sla.state.on_track': 'đúng tiến độ',
  'sla.state.at_risk': 'có rủi ro',
  'sla.list.subtitle': 'Đặt mục tiêu phản hồi đầu tiên và giải quyết theo từng mức độ ưu tiên. Các chính sách được đánh giá từ trên xuống dưới — chính sách đầu tiên có điều kiện khớp với ticket sẽ được áp dụng.',
  'sla.list.newPolicy': 'Chính sách mới',
  'sla.list.emptyTitle': 'Tạo chính sách SLA đầu tiên của bạn',
  'sla.list.emptyDescription': 'Dùng Chính sách mới để đặt mục tiêu phản hồi đầu tiên và giải quyết theo từng mức độ ưu tiên.',
  'sla.list.moveUp': 'Di chuyển lên',
  'sla.list.moveDown': 'Di chuyển xuống',
  'sla.list.frShort': 'PHĐT: {value}',
  'sla.list.resolveShort': 'Giải quyết: {value}',
  'sla.list.escalateShort': 'Leo thang: +{value}',
  'sla.list.deactivate': 'Vô hiệu hóa',
  'sla.list.activate': 'Kích hoạt',
  'sla.list.setDefault': 'Đặt làm mặc định',
  'sla.list.duplicate': 'Nhân bản',
  'sla.list.deleteTitle': 'Xóa “{name}”?',
  'sla.list.deleteDescription': 'Các ticket khớp với chính sách này sẽ dùng chính sách SLA khả dụng tiếp theo.',
  'sla.list.deleteConfirm': 'Xóa chính sách',
  'sla.conditions.groups': '{count} nhóm',
  'sla.conditions.companies': '{count} công ty',
  'sla.conditions.sources': 'nguồn: {list}',
  'sla.conditions.ticketTypes': '{count} loại ticket',
  'sla.conditions.anyOf': 'bất kỳ',
  'sla.conditions.allOf': 'tất cả',
  'sla.conditions.summary': 'Điều kiện ({mode}): {parts}',
  'sla.edit.newTitle': 'Chính sách SLA mới',
  'sla.edit.editTitle': 'Chỉnh sửa chính sách SLA',
  'sla.edit.saved': 'Đã lưu chính sách SLA.',
  'sla.edit.name': 'Tên',
  'sla.edit.appliesToPriority': 'Áp dụng cho mức độ ưu tiên',
  'sla.edit.evaluationOrder': 'Thứ tự đánh giá',
  'sla.edit.evaluationOrderHint': 'Vị trí thấp hơn được đánh giá trước cho tài khoản này.',
  'sla.edit.defaultPolicy': 'Chính sách mặc định',
  'sla.edit.useAsDefault': 'Dùng làm mặc định khi không có chính sách nào khác khớp',
  'sla.edit.targets': 'Mục tiêu SLA',
  'sla.edit.firstResponse': 'Phản hồi đầu tiên',
  'sla.edit.resolution': 'Giải quyết',
  'sla.edit.autoAt75': 'Tự động ở mức 75%',
  'sla.edit.enabledAfter': 'Bật sau {value}',
  'sla.edit.clearEscalation': 'Xóa rõ ràng mục tiêu leo thang',
  'sla.edit.clearEscalationHint': 'Gửi null; nếu không chọn mục này thì trường sẽ bị bỏ qua và giá trị đã lưu được giữ nguyên.',
  'sla.edit.firstResponseMinutes': 'Phản hồi đầu tiên (phút)',
  'sla.edit.resolutionMinutes': 'Giải quyết (phút)',
  'sla.edit.escalateAfter': 'Leo thang sau (số phút quá hạn giải quyết)',
  'sla.edit.notSet': 'Chưa đặt',
  'sla.edit.remindersNote': 'Lời nhắc tự động kích hoạt ở mức 75% của khoảng thời gian phản hồi đầu tiên và giải quyết. Leo thang sẽ thông báo cho agent leo thang của nhóm ticket (đặt trên nhóm) khi mục tiêu giải quyết bị trễ quá số phút đã cấu hình.',
  'sla.edit.conditions': 'Điều kiện',
  'sla.edit.conditionsHint': 'Để trống một nhóm để khớp với mọi giá trị',
  'sla.edit.matchMode': 'Chế độ khớp:',
  'sla.edit.matchAll': 'Khớp TẤT CẢ điều kiện',
  'sla.edit.matchAny': 'Khớp BẤT KỲ điều kiện nào',
  'sla.edit.groups': 'Nhóm',
  'sla.edit.companies': 'Công ty',
  'sla.edit.sources': 'Nguồn',
  'sla.edit.ticketTypes': 'Loại ticket',
  'sla.bh.subtitle': 'Xác định lịch hằng tuần và lịch ngày nghỉ lễ mà các chính sách SLA dùng để tính ngày đến hạn.',
  'sla.bh.newCalendar': 'Lịch mới',
  'sla.bh.emptyTitle': 'Tạo lịch giờ làm việc đầu tiên của bạn',
  'sla.bh.emptyDescription': 'Dùng Lịch mới để xác định lịch hằng tuần mà các chính sách SLA dựa vào.',
  'sla.bh.accountDefault': 'Mặc định của tài khoản',
  'sla.bh.closedEveryDay': 'Đóng cửa mọi ngày',
  'sla.bh.openEveryDay': 'Mở cửa mọi ngày',
  'sla.bh.openDaysOne': 'Mở 1 ngày/tuần',
  'sla.bh.openDaysMany': 'Mở {count} ngày/tuần',
  'sla.bh.holidayOne': '1 ngày nghỉ lễ',
  'sla.bh.holidayMany': '{count} ngày nghỉ lễ',
  'sla.bh.deleteTitle': 'Xóa “{name}”?',
  'sla.bh.deleteDescription': 'Các chính sách SLA và nhóm dùng lịch này sẽ chuyển về mặc định của tài khoản.',
  'sla.bh.deleteConfirm': 'Xóa lịch',
  'sla.bh.newTitle': 'Lịch giờ làm việc mới',
  'sla.bh.editTitle': 'Chỉnh sửa giờ làm việc',
  'sla.bh.saved': 'Đã lưu giờ làm việc.',
  'sla.bh.timezone': 'Múi giờ',
  'sla.bh.defaultCalendar': 'Lịch mặc định',
  'sla.bh.useAsDefault': 'Dùng cho các chính sách SLA và nhóm không chỉ định lịch riêng',
  'sla.bh.weeklySchedule': 'Lịch hằng tuần',
  'sla.bh.colDay': 'Ngày',
  'sla.bh.colOpen': 'Mở cửa',
  'sla.bh.colStart': 'Bắt đầu',
  'sla.bh.colEnd': 'Kết thúc',
  'sla.bh.dayOpenAria': '{day} mở cửa',
  'sla.bh.dayStartAria': 'Giờ bắt đầu {day}',
  'sla.bh.dayEndAria': 'Giờ kết thúc {day}',
  'sla.bh.holidayCalendar': 'Lịch ngày nghỉ lễ',
  'sla.bh.saveFirst': 'Hãy lưu lịch này trước, rồi thêm ngày nghỉ lễ.',
  'sla.bh.holidayName': 'Tên ngày nghỉ lễ',
  'sla.bh.date': 'Ngày',
  'sla.bh.addHoliday': 'Thêm ngày nghỉ lễ',
  'sla.bh.noHolidays': 'Chưa có ngày nghỉ lễ',
  'sla.bh.noHolidaysHint': 'Thêm một ngày nghỉ lễ có ngày cụ thể ở trên để loại trừ khỏi tính toán SLA.',
  'sla.bh.remove': 'Xóa',
  'sla.day.monday': 'Thứ Hai',
  'sla.day.tuesday': 'Thứ Ba',
  'sla.day.wednesday': 'Thứ Tư',
  'sla.day.thursday': 'Thứ Năm',
  'sla.day.friday': 'Thứ Sáu',
  'sla.day.saturday': 'Thứ Bảy',
  'sla.day.sunday': 'Chủ Nhật',

  'set.ftype.single_line_text': 'Văn bản một dòng',
  'set.ftype.multi_line_text': 'Văn bản nhiều dòng',
  'set.ftype.dropdown': 'Danh sách thả xuống',
  'set.ftype.checkbox': 'Hộp kiểm',
  'set.ftype.radio': 'Nút chọn',
  'set.ftype.multiselect': 'Chọn nhiều',
  'set.ftype.lookup': 'Quan hệ tra cứu',
  'set.ftype.dependent': 'Trường phụ thuộc',
  'set.ftype.date': 'Ngày',
  'set.ftype.number': 'Số',
  'set.ftype.decimal': 'Số thập phân',
  'set.ftype.desc.lookup': 'Chọn một bản ghi từ nguồn hệ thống.',
  'set.ftype.desc.single_line_text': 'Giá trị văn bản ngắn.',
  'set.ftype.desc.multi_line_text': 'Giá trị văn bản dài.',
  'set.ftype.desc.checkbox': 'Giá trị đúng hoặc sai.',
  'set.ftype.desc.dropdown': 'Chọn một tùy chọn đã chuẩn hóa.',
  'set.ftype.desc.dependent': 'Các tùy chọn phụ thuộc vào một trường cha.',
  'set.ftype.desc.date': 'Giá trị ngày trên lịch.',
  'set.ftype.desc.number': 'Giá trị số nguyên.',
  'set.ftype.desc.decimal': 'Giá trị số thập phân.',
  'set.src.STATIC': 'Tùy chọn tĩnh',
  'set.src.AGENTS': 'Agent',
  'set.src.USERS': 'Người dùng / Khách hàng',
  'set.src.GROUPS': 'Nhóm',
  'set.src.ROLE': 'Vai trò',
  'set.src.COUNTRIES': 'Quốc gia',
  'set.src.CUSTOM': 'Danh sách thả xuống tùy chỉnh',
  'set.settings': 'Cài đặt',
  'set.ticketFields': 'Trường ticket',
  'set.ticketForms': 'Biểu mẫu ticket',
  'set.requestFailed': 'Yêu cầu không thành công. Vui lòng thử lại.',
  'set.refresh': 'Làm mới',
  'set.saving': 'Đang lưu…',
  'set.saveChanges': 'Lưu thay đổi',
  'set.default': 'Mặc định',
  'set.published': 'Đã xuất bản',
  'set.draft': 'Bản nháp',
  'set.publish': 'Xuất bản',
  'set.unpublish': 'Hủy xuất bản',
  'set.deleteForm': 'Xóa biểu mẫu',
  'set.description': 'Mô tả',
  'set.relationshipSource': 'Nguồn quan hệ',
  'set.dependsOn': 'Phụ thuộc vào {field}',
  'set.deleteFormTitle': 'Xóa “{name}”?',
  'set.deleteFormDescription': 'Biểu mẫu ticket này và cấu hình của nó sẽ bị xóa vĩnh viễn.',
  'set.formIdRequired': 'Cần có ID biểu mẫu.',
  'set.formNotFound': 'Không tìm thấy biểu mẫu ticket.',
  'set.tf.removeOption': 'Xóa {label}',
  'set.tf.noOptions': 'Chưa xác định tùy chọn nào.',
  'set.tf.addOptionPlaceholder': 'Thêm tùy chọn...',
  'set.tf.add': 'Thêm',
  'set.tf.dependsOnField': 'Phụ thuộc vào trường',
  'set.tf.selectParent': '— Chọn trường cha —',
  'set.tf.parentHelp': 'Trường thả xuống cha có giá trị được chọn quyết định các tùy chọn khả dụng của trường này.',
  'set.tf.optionMappings': 'Ánh xạ tùy chọn',
  'set.tf.savingParen': '(đang lưu...)',
  'set.tf.mappingsError': 'Không thể tải các ánh xạ',
  'set.tf.archivedParen': ' (đã lưu trữ)',
  'set.tf.mappedCount': 'Đã ánh xạ {count}',
  'set.tf.saveFirst': 'Hãy lưu trường trước để cấu hình ánh xạ tùy chọn.',
  'set.tf.newField': '{type} mới',
  'set.tf.pageDescription': 'Quản lý định nghĩa trường đã nhập, khả năng hiển thị, quy tắc bắt buộc và thứ tự dùng trong biểu mẫu ticket.',
  'set.tf.addField': 'Thêm trường',
  'set.tf.addFieldHelp': 'Kéo một loại vào danh sách trường hoặc dùng Thêm.',
  'set.tf.addType': 'Thêm {type}',
  'set.tf.registry': 'Danh bạ trường',
  'set.tf.savingOrder': 'Đang lưu thứ tự…',
  'set.tf.searchAria': 'Tìm kiếm trường ticket',
  'set.tf.searchPlaceholder': 'Tìm theo tên hoặc khóa...',
  'set.tf.filterAria': 'Lọc theo loại trường',
  'set.tf.allTypes': 'Tất cả loại trường',
  'set.tf.emptyFirstTitle': 'Thêm trường ticket đầu tiên của bạn',
  'set.tf.emptyFirstDesc': 'Kéo một loại trường từ bảng chọn hoặc dùng Thêm để tạo.',
  'set.tf.emptyFilterTitle': 'Không có trường nào khớp với các bộ lọc này',
  'set.tf.emptyFilterDesc': 'Hãy thử từ khóa khác hoặc mở rộng bộ lọc loại trường.',
  'set.tf.archived': 'Đã lưu trữ',
  'set.tf.dependent': 'Phụ thuộc',
  'set.tf.customerVisible': 'Khách hàng nhìn thấy',
  'set.tf.internal': 'Nội bộ',
  'set.tf.configuration': 'Cấu hình trường',
  'set.tf.selectTitle': 'Chọn một trường để cấu hình',
  'set.tf.selectDesc': 'Chọn một trường từ danh bạ để chỉnh sửa nhãn, quy tắc và khả năng hiển thị.',
  'set.tf.externalId': 'ID bên ngoài: {value}',
  'set.tf.sourceRenderer': 'Nguồn: {source} · Trình hiển thị: {renderer}',
  'set.tf.optionSource': 'Nguồn tùy chọn: {value}',
  'set.tf.dependsOnKey': 'Phụ thuộc vào: {value}',
  'set.tf.internalLabel': 'Nhãn nội bộ',
  'set.tf.customerLabel': 'Nhãn cho khách hàng',
  'set.tf.relationshipHelp': 'Xác định nơi các giá trị tra cứu được lấy khi chạy.',
  'set.tf.validationVisibility': 'Xác thực và hiển thị',
  'set.tf.requiredAgents': 'Bắt buộc đối với agent',
  'set.tf.requiredCustomers': 'Bắt buộc đối với khách hàng',
  'set.tf.requiredClosure': 'Bắt buộc khi đóng',
  'set.tf.displayedCustomers': 'Hiển thị cho khách hàng',
  'set.tf.customersEdit': 'Khách hàng có thể chỉnh sửa',
  'set.tf.customersFilter': 'Khách hàng có thể lọc',
  'set.tf.active': 'Đang hoạt động',
  'set.tf.dropdownOptions': 'Tùy chọn danh sách thả xuống ({count})',
  'set.tf.archiveTitle': 'Lưu trữ “{name}”?',
  'set.tf.archiveDesc': 'Trường sẽ không còn hoạt động và không khả dụng cho ticket mới. Dữ liệu ticket hiện có được giữ nguyên.',
  'set.tf.archiveField': 'Lưu trữ trường',
  'set.tf.alreadyArchived': 'Đã được lưu trữ',
  'set.tf.archivedNote': 'Các trường đã lưu trữ vẫn khả dụng cho các giá trị lịch sử.',
  'set.tfm.systemUser': 'Hệ thống',
  'set.tfm.untitled': 'Biểu mẫu chưa có tiêu đề',
  'set.tfm.pageDescription': 'Tạo các biểu mẫu có thể tái sử dụng và chọn các trường đã nhập mà agent và khách hàng có thể dùng.',
  'set.tfm.newForm': 'Biểu mẫu mới',
  'set.tfm.creating': 'Đang tạo…',
  'set.tfm.allForms': 'Tất cả biểu mẫu',
  'set.tfm.configuredOne': '{count} biểu mẫu đã cấu hình',
  'set.tfm.configuredMany': '{count} biểu mẫu đã cấu hình',
  'set.tfm.filter': 'Bộ lọc',
  'set.tfm.searchAria': 'Tìm kiếm biểu mẫu ticket',
  'set.tfm.searchPlaceholder': 'Tìm kiếm biểu mẫu…',
  'set.tfm.status': 'Trạng thái',
  'set.tfm.allStatuses': 'Tất cả trạng thái',
  'set.tfm.emptyFilterTitle': 'Không có biểu mẫu nào khớp với các bộ lọc này',
  'set.tfm.emptyFilterDesc': 'Hãy thử từ khóa khác hoặc mở rộng bộ lọc trạng thái.',
  'set.tfm.emptyFirstTitle': 'Tạo biểu mẫu ticket đầu tiên của bạn',
  'set.tfm.emptyFirstDesc': 'Tạo một biểu mẫu để bắt đầu cấu hình các trường đã nhập.',
  'set.tfm.createFirst': 'Tạo biểu mẫu đầu tiên của bạn',
  'set.tfm.colName': 'Tên',
  'set.tfm.colCreatedAt': 'Tạo lúc',
  'set.tfm.colUpdatedBy': 'Cập nhật lần cuối bởi',
  'set.tfm.colUpdatedAt': 'Cập nhật lần cuối lúc',
  'set.tfm.colPortals': 'Cổng thông tin liên kết',
  'set.tfm.colActions': 'Hành động',
  'set.tfm.notConfigured': 'Chưa cấu hình',
  'set.tfm.actionsFor': 'Hành động cho {name}',
  'set.tfm.editForm': 'Chỉnh sửa biểu mẫu',
  'set.tb.section.default.title': 'Trường mặc định',
  'set.tb.section.default.desc': 'Các trường quy trình hỗ trợ cốt lõi được nhập từ hệ thống nguồn.',
  'set.tb.section.custom.title': 'Trường tùy chỉnh',
  'set.tb.section.custom.desc': 'Các trường bổ sung được cấu hình cho quy trình hỗ trợ của bạn.',
  'set.tb.section.nested.title': 'Trường lồng nhau',
  'set.tb.section.nested.desc': 'Các trường phụ thuộc có tùy chọn theo một trường cha.',
  'set.tb.discardTitle': 'Bỏ các thay đổi chưa lưu?',
  'set.tb.discardDesc': 'Các chỉnh sửa của bạn đối với biểu mẫu ticket này chưa được lưu.',
  'set.tb.leave': 'Rời đi không lưu',
  'set.tb.nameRequired': 'Bắt buộc nhập tên biểu mẫu.',
  'set.tb.saved': 'Đã lưu biểu mẫu.',
  'set.tb.nowPublished': 'Đã xuất bản biểu mẫu.',
  'set.tb.nowUnpublished': 'Đã hủy xuất bản biểu mẫu.',
  'set.tb.admin': 'Quản trị',
  'set.tb.builder': 'Trình tạo',
  'set.tb.titleAria': 'Tiêu đề biểu mẫu',
  'set.tb.defaultLocked': 'Mặc định / đã khóa',
  'set.tb.previewPortal': 'Xem trước trên cổng thông tin',
  'set.tb.configureTitle': 'Cấu hình các trường được đưa vào biểu mẫu này.',
  'set.tb.configureDesc': 'Các thay đổi được lưu vào cơ sở dữ liệu trung tâm hỗ trợ khi bạn chọn Lưu thay đổi. Các trường bắt buộc luôn được bật.',
  'set.tb.formDetails': 'Chi tiết biểu mẫu',
  'set.tb.formDetailsHelp': 'Dùng mô tả rõ ràng để quản trị viên biết khi nào nên dùng biểu mẫu này.',
  'set.tb.descPlaceholder': 'Mô tả khi nào nên dùng biểu mẫu này…',
  'set.tb.importedFields': 'Trường đã nhập',
  'set.tb.importedHelp': 'Kéo để sắp xếp lại các trường. Dùng công tắc để đưa vào hoặc loại một trường khỏi biểu mẫu này.',
  'set.tb.noneInSection': 'Không có trường đã nhập nào trong mục này.',
  'set.tb.dragReorder': 'Kéo để sắp xếp lại',
  'set.tb.required': 'Bắt buộc',
  'set.tb.nested': 'Lồng nhau',
  'set.tb.enableField': 'Bật {label}',
  'set.tb.enabled': 'Đã bật',
  'set.tb.disabled': 'Đã tắt',
  'set.tb.emptyTitle': 'Chưa có trường nào để cấu hình',
  'set.tb.emptyDesc': 'Nhập các trường ticket để bắt đầu xây dựng biểu mẫu này.',
  'set.tb.deleting': 'Đang xóa…',
  'set.tp.loadError': 'Không thể tải bản xem trước biểu mẫu.',
  'set.tp.preview': 'Xem trước',
  'set.tp.customerPreview': 'Bản xem trước dành cho khách hàng',
  'set.tp.backToBuilder': 'Quay lại trình tạo',
  'set.tp.modeTitle': 'Chế độ xem trước',
  'set.tp.modeDesc': 'Đây là bản xem trước không gửi dữ liệu. Tất cả các trường đã bật được hiển thị theo thứ tự biểu mẫu đã lưu.',
  'set.tp.emptyTitle': 'Chưa có trường nào được bật',
  'set.tp.emptyDesc': 'Bật các trường trong trình tạo biểu mẫu để thấy chúng trong bản xem trước này.',

  'por.error.generic': 'Không thể hoàn tất yêu cầu.',
  'por.error.requestNotFound': 'Không tìm thấy yêu cầu.',
  'por.error.formUnavailable': 'Biểu mẫu yêu cầu không khả dụng.',
  'por.error.articleNotFound': 'Không tìm thấy bài viết.',
  'por.error.selectRating': 'Vui lòng chọn mức đánh giá từ 1 đến 5.',
  'por.tab.all': 'Tất cả',
  'por.list.title': 'Yêu cầu hỗ trợ của tôi',
  'por.list.description': 'Theo dõi yêu cầu của bạn và phản hồi cho nhóm hỗ trợ.',
  'por.list.newRequest': 'Yêu cầu mới',
  'por.list.knowledgeBase': 'Cơ sở kiến thức',
  'por.list.filterByStatus': 'Lọc yêu cầu theo trạng thái',
  'por.list.searchPlaceholder': 'Tìm theo chủ đề…',
  'por.list.count': '{count} yêu cầu',
  'por.list.countOne': '{count} yêu cầu',
  'por.list.emptyFilteredTitle': 'Không có yêu cầu nào khớp với chế độ xem này',
  'por.list.emptyTitle': 'Chưa có yêu cầu nào',
  'por.list.emptyFilteredDescription': 'Hãy thử tab Tất cả hoặc từ khóa tìm kiếm khác.',
  'por.list.emptyDescription': 'Gửi một yêu cầu và nhóm hỗ trợ sẽ tiếp nhận.',
  'por.list.submitFirst': 'Gửi yêu cầu đầu tiên của bạn',
  'por.col.request': 'Yêu cầu',
  'por.col.subject': 'Chủ đề',
  'por.col.status': 'Trạng thái',
  'por.col.priority': 'Mức độ ưu tiên',
  'por.col.created': 'Đã tạo',
  'por.detail.myRequests': 'Yêu cầu của tôi',
  'por.detail.reopen': 'Mở lại yêu cầu này',
  'por.detail.attachments': 'Tệp đính kèm',
  'por.detail.download': 'Tải xuống',
  'por.detail.conversation': 'Hội thoại',
  'por.detail.noReplies': 'Chưa có phản hồi nào',
  'por.detail.noRepliesHint': 'Thêm phản hồi bên dưới và nhóm hỗ trợ sẽ tiếp nhận.',
  'por.detail.reply': 'Phản hồi',
  'por.detail.replyPlaceholder': 'Viết phản hồi',
  'por.detail.sending': 'Đang gửi…',
  'por.detail.sendReply': 'Gửi phản hồi',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Xóa {name}',
  'por.submit.newRequest': 'Yêu cầu mới',
  'por.submit.defaultTitle': 'Gửi yêu cầu hỗ trợ',
  'por.submit.intro': 'Hoàn tất các trường bên dưới và gửi yêu cầu của bạn.',
  'por.submit.subjectRequired': 'Bắt buộc nhập chủ đề',
  'por.submit.descriptionRequired': 'Bắt buộc nhập mô tả',
  'por.submit.attachments': 'Tệp đính kèm',
  'por.submit.submitting': 'Đang gửi…',
  'por.submit.submit': 'Gửi yêu cầu',
  'por.kb.portal': 'Cổng thông tin',
  'por.kb.title': 'Cơ sở kiến thức',
  'por.kb.description': 'Tìm câu trả lời trước khi gửi yêu cầu.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Kết quả tìm kiếm',
  'por.kb.searchPlaceholder': 'Tìm kiếm bài viết',
  'por.kb.emptyTitle': 'Chưa có bài viết nào được xuất bản',
  'por.kb.emptyDescription': 'Gửi một yêu cầu và nhóm hỗ trợ sẽ trực tiếp giúp bạn.',
  'por.kb.noFolders': 'Không có thư mục',
  'por.kb.articles': '{count} bài viết',
  'por.kb.articlesOne': '{count} bài viết',
  'por.kb.noMatch': 'Không có bài viết nào khớp với “{query}”',
  'por.kb.folderEmpty': 'Chưa có bài viết nào trong thư mục này',
  'por.kb.noMatchHint': 'Hãy thử từ khóa ngắn hơn, hoặc gửi một yêu cầu.',
  'por.kb.folderEmptyHint': 'Hãy duyệt thư mục khác, hoặc gửi một yêu cầu.',
  'por.kb.submitRequest': 'Gửi một yêu cầu',
  'por.kb.views': '{count} lượt xem',
  'por.kb.thanks': 'Cảm ơn phản hồi của bạn!',
  'por.kb.helpful': 'Bài viết này có hữu ích không?',
  'por.kb.yes': 'Có',
  'por.kb.no': 'Không',
  'por.csat.thanksTitle': 'Cảm ơn phản hồi của bạn',
  'por.csat.thanksBody': 'Phản hồi của bạn đã được ghi nhận.',
  'por.csat.title': 'Chúng tôi đã làm tốt chưa?',
  'por.csat.request': 'Yêu cầu #{number}: {subject}',
  'por.csat.rating': 'Đánh giá',
  'por.csat.stars': '{count} sao',
  'por.csat.comment': 'Nhận xét',
  'por.csat.submit': 'Gửi phản hồi',
  'agents.tempPassword.title': 'Mật khẩu tạm thời',
  'agents.tempPassword.help': 'Đặt mật khẩu tạm thời cho agent này. Họ sẽ được yêu cầu chọn mật khẩu mới ở lần đăng nhập tiếp theo. Tối thiểu 12 ký tự.',
  'agents.tempPassword.button': 'Đặt mật khẩu tạm thời',
  'agents.tempPassword.saving': 'Đang đặt…',
  'agents.tempPassword.error': 'Không thể đặt mật khẩu tạm thời.',
  'ui.showPassword': 'Hiện mật khẩu',
  'ui.hidePassword': 'Ẩn mật khẩu',
  'dashboard.awaitingResolutionConfirmation': 'Đang chờ xác nhận giải quyết',
  'dashboard.awaitingUserReply': 'Đang chờ người dùng phản hồi',
  'dashboard.changeRequests': 'Yêu cầu thay đổi',
  'agents.tempPassword.successEmailed': 'Đã đặt mật khẩu tạm thời và gửi email cho agent.',
  'agents.tempPassword.successNotEmailed': 'Đã đặt mật khẩu tạm thời nhưng không thể gửi email. Hãy chia sẻ mật khẩu cho agent qua kênh an toàn.',
} as const;

export default vi;
